import { Autocomplete, Button, FormControlLabel, Grid, InputLabel, MenuItem, Select, TextField, Tooltip, Typography, useMediaQuery } from '@mui/material'
import React, { useCallback, useContext, useEffect, useLayoutEffect, useRef, useState } from 'react'
import styles from '../../../../../../assets/styles/componentStyles/templates.module.scss'
import { whatsappTemplateCategoryList, whatsappTemplateLanguages } from '../../../../../../utils/whatsappTemplate';
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import textAreaStyles from '../../../../../../assets/styles/componentStyles/templates.module.scss'
import agent from '../../../../../../services/api';
import BasicTemplatePreview from './previews/basicTemplatePreview';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import { checkForErrorCode, formatString, getFileTypeImgIcon, getWabaName, hasTemplateManageAccess } from '../../../../../../utils/constants';
import GlobalPageHeaderText from '../../../../../utility/globalPageHeaderText';
import { IntegrationContext, IntegrationContextPayload } from '../../../../../../context/integrationContext';
import { MetaContext, MetaContextPayload } from '../../../../../../context/metaContext';
import { styled, alpha } from '@mui/material/styles';
import Menu, { MenuProps } from '@mui/material/Menu';
import { createWhatsappTemplateHeaderVariable, createWhatsappTemplatePayload, getTemplateDetails, getWhatsappTemplateButtonTypeReponse, whatsappTemplateHeaderResponseModel, whatsappTemplateHeaderVariable, createWhatsappTemplateButton, createWhatsappTemplateButtonData, createWhatsappTemplateButtonSubFieldData, getWhatsappTemplateTypeResponse, whatsappCarouselCardData, createWhatsappTemplateHeader, createWhatsappTemplateBody, createWhatsappTemplateFooter, getWhatsappTemplateButtonSubTypeReponse, interactiveType, whatsappTemplateDynamicVariableType, getTemplateLibraryCategory } from '../../../../../../models/axiosModel';
import Required from '../../../../../utility/required';
import validator from 'validator';
import InfoIcon from '@mui/icons-material/Info';
import previewIcon from '../../../../../../assets/chatbotAssets/Chatbot-Preview-Arrow.svg'
import TemplatePreviewMobile from './previews/basicTemplatePreviewMobile';
import axios from 'axios';
import { debounce } from 'lodash';
import GlobalButton from '../../../../../utility/globalButton/button';
import { channelsBreadcrumb, homeBreadcrumb, templateMessagesBreadcrumb } from '../../../../../../utils/breadcrumb';
import { GenericDataContext, GenericDataContextPayload } from '../../../../../../context/genericDataContext';
import CarouselTemplate from './carouselTemplate';
import BasicTemplate from './basicTemplate';
import { checkErrorFromWord, defaultButtonTextForListType, getDefaultValueOfFlagAllowTracking, getInteractiveTypeName, getValidationsFromInteractiveType, isInteractiveTypeMessageCtaUrl, isInteractiveTypeMessageFlow, isTemplateTypeFlow, isInteractiveTypeMessageList, isInteractiveTypeNameList, isVisitWebsiteBtn, CAROUSEL_MAX_CHARS, maxChars, maxFooterChars, maximumAllowedButtons, isTemplateTypeCallPermissionRequest, TEMPLATE_BUTTON_FIELDS, getTemplateTypeName, canUpdateTemplate, areHeaderVariablesModified, areBodyVariablesModified, TYPE_OF_VARIABLE, validateVariableKeys, isBasicTemplate, isCarouselTemplate, getTemplateCategoryId, TEMPLATE_CATEGORY, isTemplateCategoryAuthentication, renderAuthenticationTemplateFooterText, RENDER_SECURITY_RECOMMENDATION_APPEND_TEXT, isCatalogTemplate, TEMPLATE_TYPES, BTN_SUB_TYPE_NAMES, BTN_TYPE_NAMES, isInteractiveTypeNameCatalogMessage, INTERACTIVE_TEMPLATE_TYPE } from './utils';
import Switch, { SwitchProps } from '@mui/material/Switch';
import TemplatePreviewCarousel from './previews/templatePreviewCarousel';
import TemplatePreviewCarouselView from './previews/TemplatePreviewCarouselView';
import CarouselTemplateView from './previews/carouselTemplateView';
import TemplatePreviewCarouselMobile from './previews/templatePreviewCarouselMobile';
import TemplatePreviewCarouselMobileView from './previews/TemplatePreviewCarouselMobileView';
import { tertiaryColor } from '../../../../../../utils/colors';
import GlobalTooltip from '../../../../../utility/tooltip/globalTooltip';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { getVendorField } from '../../../../../../utils/whiteLabelling';
import { META_DOCUMENTATION_URLS } from './metaConstants';
import { getInitialWhatsappTemplateObject } from '../whatsAppIntegrationConstant';
import { buildCreateFromScratchButton, createAuthenticationTemplateFromScratch, getButtonTypeIdByName, getButtonsIconByName, isInvalidExportFile } from '../../../../templatelibrary/constant';
import { useTemplateLibraryStore } from '../../../../../../store/templateLibraryStore';
import { TEMPLATE_NAME_MAX_CHARS_MESSAGE, TEMPLATE_NAME_MAX_LIMIT } from '../../../../templatelibrary/constant';
import { WhatsappTemplateContext, WhatsappTemplateContextPayload } from '../../../../../../context/whatsappTemplateContext';
import { useGenericStore } from '../../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { findWhatsAppIntegration } from '../../../../../../pages/ruleBasedInbox/utils';

const IOSSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: '#2ECA45',
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#39393D',
        }),
    },
}));

export const StyledMenu = styled((props: MenuProps & { position?: 'top' | 'bottom' }) => {
    const { position = 'bottom', ...otherProps } = props;

    return (
        <Menu
            elevation={0}
            anchorOrigin={{
                vertical: position === 'top' ? 'top' : 'bottom',
                horizontal: 'left',
            }}
            transformOrigin={{
                vertical: position === 'top' ? 'bottom' : 'top',
                horizontal: 'left',
            }}
            slotProps={{
                paper: {
                    sx: {
                        mt: position === 'bottom' ? 1 : 0,
                        mb: position === 'top' ? 1 : 0,
                        ml: "-1px"
                    },
                },
            }}
            {...otherProps}
        />
    );
})(({ theme, position }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: position === 'top' ? theme.spacing(-1) : theme.spacing(1),
        minWidth: 180,
        color:
            theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
    },
}));

const TemplateDetails = () => {
    const navigate = useNavigate()
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const headerTextareaCarouselRef = useRef<HTMLTextAreaElement>(null);
    const { setFlagLoading, flagLoading, handleError, vendorData, apiRoutesPermissionAssignment, userDetail } = useContext(UserContext) as UserContextPayload
    const { setShowIntegrationDetails } = useContext(MetaContext) as MetaContextPayload
    const { getIntegrationList, getMetaIntegrationList, integrationListNewStructure, setIntegrationDetails } = useContext(IntegrationContext) as IntegrationContextPayload
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;

    const { showInfo, showSuccess, showError } = useGenericStore(useShallow((state) => ({
        showInfo: state.showInfo,
        showSuccess: state.showSuccess,
        showError: state.showError
    })))

    const { importLegacyTemplatePayload, setImportLegacyTemplatePayload, setImportLegacyTemplateName, setImportLegacyTemplateJson, 
        setImportLegacyTemplateFile, setImportLegacyTemplateFileName, setImportLegacyTemplateSelectedTab } = useContext(WhatsappTemplateContext) as WhatsappTemplateContextPayload;

    const [addBtnOpenMenu, setAddBtnOpenMenu] = useState<boolean>(false)
    const [templateStatusDetails, setTemplateStatusDetails] = useState<getTemplateDetails | null>(null)
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const viewPayloadScreen = useMediaQuery('(min-width: 0px) and (max-width : 1600px)')

    const [openSwipableDrawer, setOpenSwipableDrawer] = useState<boolean>(false)
    const [files, setFiles] = useState<any>([]);
    const [carouselFiles, setCarouselFiles] = useState<any>([{
        index: 0,
        carousels: []
    }, {
        index: 1,
        carousels: []
    }]);
    const [progress, setProgress] = useState({ filename: "", percent: 0 });
    const [isFileUploaded, setIsFileUploaded] = useState<boolean>(false);
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1200px)')
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)')
    const tabletScreen = useMediaQuery('(max-width : 760px) and (min-width : 600px)')
    const [whastappTemplateHeaderTypes, setWhatsappTemplateHeaderTypes] = useState<whatsappTemplateHeaderResponseModel[] | null>(null)
    const [whatsappTemplateDynamicVarTypes, setWhatsappTemplateDynamicVaribaleTypes] = useState<whatsappTemplateDynamicVariableType[] | null>(null);
    const [whatsappTemplateButtonGenericData, setWhatsappTemplateButtonGenericData] = useState<getWhatsappTemplateButtonTypeReponse[] | null>(null)
    const [whatsappTemplateTypes, setWhatsappTemplateTypes] = useState<getWhatsappTemplateTypeResponse[] | null>(null)

    const templateCategoryList = useTemplateLibraryStore((state) => state.templateLibraryCategoryList);
    const getTemplateLibraryCategoryListApiCall = useTemplateLibraryStore((state) => state.getTemplateLibraryCategoryListApiCall);
    const templateLibraryCategoryList = useTemplateLibraryStore((state) => state.templateLibraryCategoryList);
    const templateLibraryDraftList = useTemplateLibraryStore((state) => state.templateLibraryDraftList);
    const getTemplateLibraryDraftListApiCall = useTemplateLibraryStore((state) => state.getTemplateLibraryDraftListApiCall);

    const innerHeight = smallScreen ? (window.innerHeight - 145) : tabletScreen ? (window.innerHeight - 170) : (window.innerHeight - 160);
    const pathname = window.location.pathname.toLowerCase()
    const [menuPosition, setMenuPosition] = React.useState<'top' | 'bottom'>('bottom');

    const fileRef = useRef<any[]>([]);
    const importPayloadAppliedRef = useRef<boolean>(false);

    const toggleDrawer = (newOpen: boolean) => () => {
        setOpenSwipableDrawer(newOpen);
    };

    useEffect(() => {
        const handleResize = () => {
            if (open && anchorEl) {
                const position = calculateMenuPosition(anchorEl);
                setMenuPosition(position);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [open, anchorEl]);

    const calculateMenuPosition = (anchorElement: HTMLElement) => {
        if (!anchorElement) return 'bottom';

        const rect = anchorElement.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        const menuItemHeight = 48;
        const menuItemCount = whatsappTemplateButtonGenericData?.reduce((total: number, btnOption: any) => {
            return total + 1 + btnOption.whatsapp_template_button_sub_type_data.length;
        }, 0) || 0;
        const menuHeight = Math.min(menuItemCount * menuItemHeight + 100, 400);

        const spacing = 8;

        const spaceBelow = viewportHeight - rect.bottom - spacing;
        const spaceAbove = rect.top - spacing;

        if (spaceBelow < menuHeight && spaceAbove >= menuHeight) {
            return 'top';
        }

        if (spaceAbove < menuHeight && spaceBelow >= menuHeight) {
            return 'bottom';
        }

        if (spaceBelow >= spaceAbove) {
            return 'bottom';
        } else {
            return 'top';
        }
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        const position = calculateMenuPosition(event.currentTarget);
        setMenuPosition(position);

        setAnchorEl(event.currentTarget);
    };
    const [searchParamsId, setSearchParamsId] = useSearchParams()
    let id = searchParamsId.get('id')
    let template_id = searchParamsId.get('template_id');
    let draftId = searchParamsId.get('draft_id');

    const [inValidId, setInvalidId] = useState<any>([]);
    const [carouselInvalidId, setCarouselInvalidId] = useState<any>([
        {
            index: 0,
            inValidIds: []
        },
        {
            index: 1,
            inValidIds: []
        }
    ])

    const inValidIdRef = useRef<any[]>([]);
    const inValidIdRefCarousel = useRef<any[]>([
        {
            index: 0,
            inValids: []
        },
        {
            index: 1,
            inValids: []
        }
    ]);
    const [existingPayloadKey, setExistingPayloadKey] = useState<any>([]);

    // console.log('inValidIdRef---', inValidIdRef.current)
    const handleClose = () => {
        setAnchorEl(null);
    };

    const [createTemplatePayload, setCreateTemplatePayload] = useState<createWhatsappTemplatePayload>(getInitialWhatsappTemplateObject(whatsappTemplateTypes, false, templateCategoryList ?? []));
    const [existingTemplateData, setExistingPayloadData] = useState<createWhatsappTemplatePayload>(getInitialWhatsappTemplateObject(whatsappTemplateTypes, false, templateCategoryList ?? []));

    useEffect(() => {
        setCreateTemplatePayload(getInitialWhatsappTemplateObject(whatsappTemplateTypes, false, templateCategoryList ?? []));
        setExistingPayloadData(getInitialWhatsappTemplateObject(whatsappTemplateTypes, false, templateCategoryList ?? []));
    }, [whatsappTemplateTypes, templateCategoryList]);
    
    const [existingHeaderTemplateVariableData, setExistingHeaderTemplateVariableData] = useState<(whatsappTemplateHeaderVariable | createWhatsappTemplateHeaderVariable)[] | null>([]);

    const [publishedFlowList, setPublishedFlowList] = useState<any>(null);
    const [invalidPayloadObjectId, setInvalidPayloadObjectId] = useState<number[]>([]);

    const [interactiveTypeList, setInteractiveTypeList] = useState<interactiveType[] | null>(null);

    const [searchParams] = useSearchParams()

    const isAuthenticationTemplate = isTemplateCategoryAuthentication(templateLibraryCategoryList, createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id);

    const resetImportLegacyTemplateState = () => {
        setImportLegacyTemplatePayload(null);
        setImportLegacyTemplateName(null);
        setImportLegacyTemplateJson(null);
        setImportLegacyTemplateFile(null);
        setImportLegacyTemplateFileName(null);
        setImportLegacyTemplateSelectedTab(0);
    }

    const getWhatsappTemplateHeaderTypes = async () => {
        const response = await agent.whatsappTemplateHeaderType.get();
        if (response.status) {
            setWhatsappTemplateHeaderTypes(response.data)
        } else {
            // handleError(response);
        }
    }

    const getWhatsappTemplateDynamicVarTypes = async () => {
        const response = await agent.whatsappTemplateDynamicVariableType.get();
        if (response.status) {
            setWhatsappTemplateDynamicVaribaleTypes(response.data)
        } else {
            // handleError(response);
        }
    }

    const getWhatsappTemplateButtonType = async () => {
        const response = await agent.getWhatsappTemplateButtonType.get();
        if (response.status) {
            setWhatsappTemplateButtonGenericData(response.data)
        } else {
            // handleError(response);
        }
    }

    const getWhatsappTemplateTypes = async () => {
        const response = await agent.getWhatsappTemplateType.get();
        if (response.status) {
            const allowedTemplateTypes = response.data?.filter((template: getWhatsappTemplateTypeResponse) => 
                !isTemplateTypeFlow(template?.name) && !isTemplateTypeCallPermissionRequest(template?.name)
            );
            setWhatsappTemplateTypes(allowedTemplateTypes)
        } else {
            setWhatsappTemplateTypes(null)
            // handleError(response);
        }
    }

    useLayoutEffect(() => {
        (async () => {
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))

            if(!searchParams.has('template_id') && searchParams.has('id') && !hasTemplateManageAccess(apiRoutesPermissionAssignment, userDetail)){
                // Restrict user to create template if user don't have access.
                navigate(`/channels/viewintegration/whatsapp/templatemessages?id=${id}`);
            }

            if (!templateCategoryList) {
                await getTemplateLibraryCategoryListApiCall();
            }

            if(draftId && !templateLibraryDraftList) {
                await getTemplateLibraryDraftListApiCall();
            }

            await getWhatsappTemplateButtonType()
            await getWhatsappTemplateHeaderTypes()
            await getWhatsappTemplateDynamicVarTypes()
            await getWhatsappTemplateTypes()
            const res = await getMetaIntegrationList(true)
            if (!(res.status)) {
                handleError(res);
            }
            setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
        })()
    }, []);

    const updateCreateTemplatepayload = (updatedVal: any) => {

        if (searchParams.get('copy_template')) {
            const updated_value = {
                ...updatedVal,
                whatsapp_template_metadata: {
                    ...updatedVal.whatsapp_template_metadata,
                    meta_whatsapp_template_status_id: 0,
                    meta_whatsapp_template_status_name: "",
                }
            }
            setTemplateStatusDetails(updated_value);
        } else {
            setTemplateStatusDetails(updatedVal)
        }
        let templateButtonData = updatedVal?.whatsapp_template_data?.[0]?.whatsapp_template_button?.map((btn: any) => (
            {
                ...btn, whatsapp_template_button_data: btn?.whatsapp_template_button_data?.map((data: any) => {
                    return {
                        ...data, whatsapp_template_button_sub_type_field_data: data?.whatsapp_template_button_sub_type_field_data?.map((field: any) => {
                            let subFieldData = whatsappTemplateButtonGenericData?.find((genericBtn) => genericBtn?.whatsapp_template_button_type_id == btn?.whatsapp_template_button_type_id)?.whatsapp_template_button_sub_type_data?.find((subBtn) => subBtn?.whatsapp_template_button_sub_type_id == data?.whatsapp_template_button_sub_type_id)?.whatsapp_template_button_sub_type_field_data?.find((genericField) => genericField?.whatsapp_template_button_sub_type_field_id == field?.whatsapp_template_button_sub_type_field_id)

                            return {
                                ...subFieldData,
                                ...field,
                            }
                        })
                    }
                })
            }
        ))

        let updatedHeader = updatedVal?.whatsapp_template_data?.[0]?.whatsapp_template_header;
        if (updatedHeader?.whatsapp_template_header_type_name === null) {
            updatedHeader.whatsapp_template_header_type_name = "None";
        }

        const updatedPayload = {
            whatsapp_template_id: searchParams.get('copy_template') ? null : updatedVal.whatsapp_template_id,
            "meta_integration_whatsapp_id": updatedVal?.meta_integration_whatsapp_id,
            "whatsapp_template_flag_interactive_message": updatedVal?.whatsapp_template_flag_interactive_message,
            "whatsapp_template_flag_flow": updatedVal?.whatsapp_template_flag_flow,
            "interactive_type_id": updatedVal?.interactive_type?.interactive_type_id ?? null,
            "interactive_type_name": updatedVal?.interactive_type?.interactive_type_name ?? null,
            "interactive_list_button_text": updatedVal?.interactive_list_button_text ?? null,
            "flag_named_parameter": updatedVal?.flag_named_parameter ?? false,
            "whatsapp_template_type_id": updatedVal?.whatsapp_template_type?.whatsapp_template_type_id,
            "whatsapp_template_data": {
                whatsapp_template_data_id: updatedVal?.whatsapp_template_data[0]?.whatsapp_template_data_id,
                "whatsapp_template_category_id": updatedVal?.whatsapp_template_data[0]?.whatsapp_template_category_id,
                "whatsapp_language_id": updatedVal?.whatsapp_template_data[0]?.whatsapp_language_data?.whatsapp_language_id,
                "whatsapp_template_name": updatedVal?.whatsapp_template_data[0]?.whatsapp_template_name,
                "whatsapp_template_description": updatedVal?.whatsapp_template_data[0]?.whatsapp_template_description,
                "whatsapp_template_header": updatedVal?.whatsapp_template_data[0]?.whatsapp_template_header,
                "whatsapp_template_body": updatedVal?.whatsapp_template_data[0]?.whatsapp_template_body,
                "whatsapp_template_button": templateButtonData,
                "whatsapp_template_footer": updatedVal?.whatsapp_template_data[0]?.whatsapp_template_footer,
                "whatsapp_template_carousel": {
                    "whatsapp_template_carousel_header": updatedVal?.whtatsapp_carousel_header,
                    "whatsapp_template_carousel_header_dynamic_variable": updatedVal?.whtatsapp_carousel_header_variable_data,
                    "whatsapp_template_carousel_card": updatedVal?.whatsapp_template_data?.map((cards: any) => ({
                        "whatsapp_template_header": cards?.whatsapp_template_header,
                        "whatsapp_template_body": cards?.whatsapp_template_body,
                        "whatsapp_template_button": cards?.whatsapp_template_button,
                        "whatsapp_template_footer": cards?.whatsapp_template_footer
                    }))
                },
                "whatsapp_template_security_recommendation": updatedVal?.whatsapp_template_data?.[0]?.whatsapp_template_security_recommendation,
                "whatsapp_template_code_expiration_minutes": updatedVal?.whatsapp_template_data?.[0]?.whatsapp_template_code_expiration_minutes,
            }
        }
        setCreateTemplatePayload(updatedPayload)
        setExistingPayloadData(updatedPayload);

        setText(updatedVal.whatsapp_template_data[0].whatsapp_template_body.whatsapp_template_body_value);
        setCarouselHeaderText(updatedVal?.whtatsapp_carousel_header)
        setFooterText(updatedVal.whatsapp_template_data[0].whatsapp_template_footer?.whatsapp_template_footer_value || "");
        setExistingHeaderTemplateVariableData(updatedVal.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data);
        const headerType = updatedVal?.whatsapp_template_data?.[0]?.whatsapp_template_header?.whatsapp_template_header_type_name;
        if (updatedVal?.whatsapp_template_type?.name?.toLowerCase() == "basic" && headerType !== null) {
            getHeaderFiles(updatedVal.whatsapp_template_data[0].whatsapp_template_header.whatsapp_template_header_data[0]?.whatsapp_template_header_data_google_storage_id,
                updatedVal.whatsapp_template_data[0].whatsapp_template_header.whatsapp_template_header_data[0]?.whatsapp_template_header_data_value,
                headerType
            );
        }
        if (updatedVal?.whatsapp_template_type?.name?.toLowerCase() == "carousel" && headerType !== null) {
            updatedVal?.whatsapp_template_data?.map((wData: any, cardIndex: number) => getCarouselHeaderFiles(wData.whatsapp_template_header.whatsapp_template_header_data[0]?.whatsapp_template_header_data_google_storage_id,
                wData.whatsapp_template_header.whatsapp_template_header_data[0]?.whatsapp_template_header_data_value,
                headerType, cardIndex
            ));
        }

        if (updatedVal.whatsapp_template_flag_flow && !publishedFlowList) {
            getFlowListApi();
        }

        if (updatedVal?.interactive_type?.interactive_type_id && !interactiveTypeList) {
            getInteractiveTypeApi();
        }

        resetImportLegacyTemplateState();
    }

    const getHeaderFiles = async (id: string, file_path: string, headerType: string) => {
        // setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        if (id) {
            const res = await axios.get(`${getVendorField(vendorData, "backend api", process.env.REACT_APP_BASE_URL)}/api/storage/file?file_id=${id}&flag_info=true`);
            if (res.data.status) {
                const file = {
                    file_data: {
                        file_path: file_path,
                        flag_deleted: false,
                        flag_saved: false,
                        google_storage_file_name: res.data.data?.file_name,
                        google_storage_file_self_link: res.data.data?.self_link,
                        google_storage_flag_public: true,
                        google_storage_id: res.data.data?.google_storage_id,
                        google_storage_original_file_id: res.data.data?.storage_bucket_id,
                        google_storage_original_file_name: res.data.data?.original_file_name,
                        goolge_storage_file_size: res.data.data?.file_size,
                        goolge_storage_file_type: headerType.toLowerCase() === "image" ? ".jpg" : ".mp4",
                        history_id: null,
                        timestamp: res.data.data?.uploaded_at,
                        user_assignment_id: res.data.data?.user_assignment_id,
                    },
                    google_storage_id: res.data.data?.google_storage_id,
                    isUploading: false,
                    previewImageSrc: getFileTypeImgIcon(headerType.toLowerCase() === "image" ? "jpg" : "mp4"),
                    name: res.data.data?.original_file_name,
                    size: Number(res.data.data?.file_size),
                }
                setFiles([file]);
                if (fileRef && fileRef.current && fileRef.current.length > 0) {
                    for (let i = 0; i < fileRef.current.length; ++i) {
                        if (fileRef.current[i].file_data.google_storage_id != res.data.data?.google_storage_id) {
                            removeUploadedFile(fileRef.current[i].file_data.google_storage_id, false);
                        }
                    }
                    fileRef.current = fileRef.current.filter((file) => {
                        return file.file_data.google_storage_id == res.data.data?.google_storage_id;
                    });
                }
                fileRef.current = [file];
            }
            else {
                handleError(res.data);
            }
        }
        // setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }

    const getCarouselHeaderFiles = async (id: string, file_path: string, headerType: string, cardIndex: number) => {
        // setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        if (id) {
            const res = await axios.get(`${getVendorField(vendorData, "backend api", process.env.REACT_APP_BASE_URL)}/api/storage/file?file_id=${id}&flag_info=true`);
            if (res.data.status) {
                const file = {
                    file_data: {
                        file_path: file_path,
                        flag_deleted: false,
                        flag_saved: false,
                        google_storage_file_name: res.data.data?.file_name,
                        google_storage_file_self_link: res.data.data?.self_link,
                        google_storage_flag_public: true,
                        google_storage_id: res.data.data?.google_storage_id,
                        google_storage_original_file_id: res.data.data?.storage_bucket_id,
                        google_storage_original_file_name: res.data.data?.original_file_name,
                        goolge_storage_file_size: res.data.data?.file_size,
                        goolge_storage_file_type: headerType.toLowerCase() === "image" ? ".jpg" : ".mp4",
                        history_id: null,
                        timestamp: res.data.data?.uploaded_at,
                        user_assignment_id: res.data.data?.user_assignment_id,
                    },
                    google_storage_id: res.data.data?.google_storage_id,
                    isUploading: false,
                    previewImageSrc: getFileTypeImgIcon(headerType.toLowerCase() === "image" ? "jpg" : "mp4"),
                    name: res.data.data?.original_file_name,
                    size: Number(res.data.data?.file_size),
                }
                let data = {
                    index: cardIndex,
                    carousels: [file]
                }
                setCarouselFiles((prev: any) => {
                    const updated = prev.filter((item: any) => item.index !== cardIndex);
                    return [...updated, data];
                });
                // if (fileRef && fileRef.current && fileRef.current.length > 0) {
                //     for (let i = 0; i < fileRef.current.length; ++i) {
                //         if (fileRef.current[i].file_data.google_storage_id != res.data.data?.google_storage_id) {
                //             removeUploadedFile(fileRef.current[i].file_data.google_storage_id, false);
                //         }
                //     }
                //     fileRef.current = fileRef.current.filter((file) => {
                //         return file.file_data.google_storage_id == res.data.data?.google_storage_id;
                //     });
                // }
                // fileRef.current = [file];
            }
            else {
                handleError(res.data);
            }
        }
        // setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }

    const getTemplateDetails = async (whatsapp_meta_integration_id: number, template_id: number, meta_integration_id: number | string) => {
        const response = await agent.getWhatsappTemplateDetails.get(whatsapp_meta_integration_id, template_id)
        if (response.status) {
            updateCreateTemplatepayload(response.data[0])
        } else {
            // navigate(`/channels/viewintegration/whatsapp/legacy/templateinfo?id=${meta_integration_id}`)
            navigate(`/channels/viewintegration/whatsapp/templatelibrary/modifyTemplate?id=${meta_integration_id}`)
        }
    }

    useEffect(() => {
        if (searchParams.has('id')) {
            if (integrationListNewStructure && integrationListNewStructure.length > 0) {
                let id = searchParams.get('id')
                let meta_integration_id = id ?? 1

                let integration = findWhatsAppIntegration(integrationListNewStructure, id ?? '');

                if (integration) {
                    let whatsapp_meta_integration_id = integration.meta_integration_whatsapp_id
                    setCreateTemplatePayload((prevState: any) => ({ ...prevState, meta_integration_whatsapp_id: whatsapp_meta_integration_id }))
                    setIntegrationDetails(integration)
                    if (searchParams.has('template_id')) {
                        let template_id = Number(searchParams.get('template_id')) ?? 1;
                        getTemplateDetails(whatsapp_meta_integration_id, template_id, meta_integration_id)
                    }
                    else if(importLegacyTemplatePayload) {
                        if (isInvalidExportFile(importLegacyTemplatePayload)) {
                            showError("Invalid file")
                            resetImportLegacyTemplateState();
                            return;
                        }
                        importPayloadAppliedRef.current = true;
                        updateCreateTemplatepayload(importLegacyTemplatePayload)
                    }
                    else if (importPayloadAppliedRef.current) {
                        return;
                    }
                    else if (searchParams.has('copy_template')) {
                        let template_id = Number(searchParams.get('copy_template')) ?? 1;
                        getTemplateDetails(whatsapp_meta_integration_id, template_id, meta_integration_id)
                    }
                    else if (searchParams.has('draft_id')) {
                        let draft_id = searchParams.get('draft_id') ?? "";
                        const draftTemplate = templateLibraryDraftList?.find((draft) => draft?.whatsapp_template_draft_id === draft_id);
                        const draftData = JSON.parse(draftTemplate?.json_data ?? "");
                        if(draftData) {
                            updateCreateTemplatepayload(draftData);
                        }
                    }
                }
            }
        } else {
            setIntegrationDetails(null)
            setShowIntegrationDetails(false)
        }
    }, [integrationListNewStructure, importLegacyTemplatePayload])

    const [text, setText] = useState('');
    const [carouselHeaderText, setCarouselHeaderText] = useState('');
    const [footerText, setFooterText] = useState('');


    const [actions, setActions] = useState<any>([]);
    const [quickReply, setQuickReply] = useState<any>([]);

    const handleChangeText = (event: any, type: any) => {
        if (type == "format") {
            if (event.target.value.length <= maxChars) {
                setText(event.target.value);
            }
        }
        else if (type == "footer") {
            if (event.target.value.length <= maxFooterChars)
                setFooterText(event.target.value)
        }
        else if (type == "carouselheader") {
            if (event.target.value.length <= CAROUSEL_MAX_CHARS?.HEADER_TEXT)
                setCarouselHeaderText(event.target.value)
        }
    };

    const handleQuickReplyChange = (id: any, value: any) => {
        const newQuickReply = quickReply.map((ele: any) => {
            if (id == ele.id) {
                return { ...ele, value }
            }
            return ele
        })
        setQuickReply(newQuickReply)
    }

    const getExistingActionButtonId = (buttonTypeId: number) => {
        let existingButton = existingTemplateData.whatsapp_template_data.whatsapp_template_button.find((button) => Number(button.whatsapp_template_button_type_id) == buttonTypeId)
        if (existingButton) {
            let buttonId = existingButton.whatsapp_template_button_id
            return buttonId
        } else {
            return null
        }
    }

    const getExistingActionButtonIdCarousel = (buttonTypeId: number) => {
        let existingButton = existingTemplateData?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_button.find((button) => Number(button.whatsapp_template_button_type_id) == buttonTypeId)
        if (existingButton) {
            let buttonId = existingButton.whatsapp_template_button_id
            return buttonId
        } else {
            return null
        }
    }

    const getExistingActionButtonDataIdCarousel = (buttonTypeId: number, subTypeId: number, index?: number) => {
        let existingButton = existingTemplateData?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_button.find((button) => Number(button.whatsapp_template_button_type_id) == buttonTypeId)
        if (existingButton) {
            let subButtonData = existingButton?.whatsapp_template_button_data?.filter((subBtn) => subBtn?.whatsapp_template_button_sub_type_id == subTypeId)
            if (subButtonData && subButtonData.length > 0)
                var currentSubBtnData = [];
            let currentButtonData = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_button.find((btn) => Number(btn.whatsapp_template_button_type_id) == buttonTypeId)
            let subBtnId = null
            if (index !== undefined) {
                let subBtndata = subButtonData[index]
                if (subBtndata && subBtndata?.whatsapp_template_button_data_id) {
                    subBtnId = subButtonData[index]?.whatsapp_template_button_data_id
                } else {
                    subBtnId = subButtonData?.[0]?.whatsapp_template_button_data_id ?? null
                }
            } else {
                if (currentButtonData) {
                    currentSubBtnData = currentButtonData?.whatsapp_template_button_data?.filter((subBtn) => subBtn?.whatsapp_template_button_sub_type_id == subTypeId)
                    let subBtndata = subButtonData?.[currentSubBtnData?.length]
                    if (subBtndata) {
                        subBtnId = subButtonData?.[currentSubBtnData?.length]?.whatsapp_template_button_data_id
                    }
                } else {
                    subBtnId = subButtonData[0]?.whatsapp_template_button_data_id
                }
            }
            return subBtnId
        } else {
            return null
        }
    }

    const getExistingActionButtonDataId = (buttonTypeId: number, subTypeId: number, index?: number) => {
        let existingButton = existingTemplateData.whatsapp_template_data.whatsapp_template_button.find((button) => Number(button.whatsapp_template_button_type_id) == buttonTypeId)
        if (existingButton) {
            let subButtonData = existingButton?.whatsapp_template_button_data.filter((subBtn) => subBtn?.whatsapp_template_button_sub_type_id == subTypeId)
            if (subButtonData && subButtonData.length > 0)
                var currentSubBtnData = [];
            let currentButtonData = createTemplatePayload.whatsapp_template_data.whatsapp_template_button.find((btn) => Number(btn.whatsapp_template_button_type_id) == buttonTypeId)
            let subBtnId = null
            if (index !== undefined) {
                let subBtndata = subButtonData[index]
                if (subBtndata && subBtndata?.whatsapp_template_button_data_id) {
                    subBtnId = subButtonData[index].whatsapp_template_button_data_id
                } else {
                    subBtnId = subButtonData[0]?.whatsapp_template_button_data_id ?? null
                }
            } else {
                if (currentButtonData) {
                    currentSubBtnData = currentButtonData?.whatsapp_template_button_data?.filter((subBtn) => subBtn?.whatsapp_template_button_sub_type_id == subTypeId)
                    let subBtndata = subButtonData[currentSubBtnData.length]
                    if (subBtndata) {
                        subBtnId = subButtonData[currentSubBtnData.length]?.whatsapp_template_button_data_id
                    }
                } else {
                    subBtnId = subButtonData[0]?.whatsapp_template_button_data_id
                }
            }
            return subBtnId
        } else {
            return null
        }
    }

    const reOrderButtonFieldForCustomBtn = (selectedSubButton: getWhatsappTemplateButtonSubTypeReponse) => {
        const buttonDescriptionField = [];
        const payloadField = [];
        const otherFields = [];

        for (const item of selectedSubButton.whatsapp_template_button_sub_type_field_data) {
            const fieldName = item.field_name.toLowerCase();
            switch (fieldName) {
                case "button description":
                    buttonDescriptionField.push({
                        ...item,
                        whatsapp_template_button_sub_type_field_value: "",
                        whatsapp_template_button_sub_type_field_option_id: null,
                    });
                    break;
                case "payload":
                    payloadField.push({
                        ...item,
                        whatsapp_template_button_sub_type_field_value: [],
                        whatsapp_template_button_sub_type_field_option_id: null,
                    });
                    break;
                default:
                    otherFields.push({
                        ...item,
                        whatsapp_template_button_sub_type_field_value: "",
                        whatsapp_template_button_sub_type_field_option_id: null,
                    });
                    break;
            }
        }

        if (createTemplatePayload.whatsapp_template_flag_interactive_message && getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList)?.show_btn_description_field) {
            const reOrderedArray = [...otherFields, ...buttonDescriptionField, ...payloadField];
            return reOrderedArray;
        } else {
            return [...otherFields, ...payloadField];
        }
    }

    const getNewBtnType = (buttonTypeId: number, subTypeId: number) => {
        const selectedSubButton = whatsappTemplateButtonGenericData?.find((btn: any) => btn.whatsapp_template_button_type_id == buttonTypeId)?.whatsapp_template_button_sub_type_data?.find((subType: any) => subType?.whatsapp_template_button_sub_type_id == subTypeId);
        const isCustom = selectedSubButton?.whatsapp_template_button_sub_type_name?.toLowerCase() == "custom";
        let reorderedFields = selectedSubButton?.whatsapp_template_button_sub_type_field_data.map((field) => ({
            ...field,
            "whatsapp_template_button_sub_type_field_value": field.field_name.toLowerCase() == "payload" ? [] : "",
            "whatsapp_template_button_sub_type_field_option_id": null
        }));
        if (selectedSubButton && isCustom) {
            reorderedFields = reOrderButtonFieldForCustomBtn(selectedSubButton);
        }
        const newButtonType = {
            "whatsapp_template_button_id": getExistingActionButtonId(buttonTypeId),
            "flag_allow_tracking": getDefaultValueOfFlagAllowTracking(selectedSubButton?.whatsapp_template_button_sub_type_name, whatsappTemplateTypes?.find((types) => types.whatsapp_template_type_id == createTemplatePayload?.whatsapp_template_type_id)?.name || ""),
            "whatsapp_template_button_type_id": buttonTypeId,
            "whatsapp_template_button_data": [
                {
                    "whatsapp_template_button_data_id": getExistingActionButtonDataId(buttonTypeId, subTypeId),
                    "whatsapp_template_button_sub_type_id": subTypeId,
                    "whatsapp_template_button_sub_type_name": selectedSubButton?.whatsapp_template_button_sub_type_name,
                    "whatsapp_template_button_sub_type_field_data": reorderedFields,
                }
            ]
        };
        return newButtonType;
    }

    const isFlowButton = (buttonTypeId: number) => {
        const flowButton = whatsappTemplateButtonGenericData?.find((btn) => btn.whatsapp_template_button_type_id == buttonTypeId);
        if (flowButton) {
            return flowButton?.whatsapp_template_button_type_name?.toLowerCase() == "flow";
        }
        return false;
    }

    const addButtonWithSubTypeGrouping = (existingButtons: createWhatsappTemplateButton[], newButton: ReturnType<typeof getNewBtnType>, subTypeId: number) => {
        const lastIndexOfNewBtn = existingButtons?.map((btn: createWhatsappTemplateButton) => btn?.whatsapp_template_button_data?.[0]?.whatsapp_template_button_sub_type_id)?.lastIndexOf(subTypeId);
        const btnsBeforeNewBtn = existingButtons?.slice(0, lastIndexOfNewBtn + 1) ?? [];
        const btnsAfterNewBtn = existingButtons?.slice(lastIndexOfNewBtn + 1) ?? [];

        // If same subTypeId exists, insert after last occurance
        if(lastIndexOfNewBtn !== -1){
            // We need to group buttons that share the same sub-type ID; otherwise, Meta will return an error.
            return [
                ...btnsBeforeNewBtn, 
                newButton,
                ...btnsAfterNewBtn
            ];
        }

        // If no matching subTypeId, append at the end
        return [...existingButtons, newButton];
    }

    const handleAddActionsButton = (buttonTypeId: number, subTypeId: number) => {
        // old code according to old structure
        // setCreateTemplatePayload((prevState: any) => {
        //     const newButtonType = {
        //         whatsapp_template_button_id: getExistingActionButtonId(buttonTypeId),
        //         "whatsapp_template_button_type_id": buttonTypeId,
        //         "whatsapp_template_button_data": [
        //             {
        //                 whatsapp_template_button_data_id: getExistingActionButtonDataId(buttonTypeId, subTypeId),
        //                 "whatsapp_template_button_sub_type_id": subTypeId,
        //                 "whatsapp_template_button_sub_type_field_data": whatsappTemplateButtonGenericData?.find((btn: any) => btn.whatsapp_template_button_type_id == buttonTypeId)?.whatsapp_template_button_sub_type_data?.find((subType: any) => subType.whatsapp_template_button_sub_type_id == subTypeId)?.whatsapp_template_button_sub_type_field_data.map((field) => ({
        //                     ...field,
        //                     "whatsapp_template_button_sub_type_field_value": field.field_name.toLowerCase() == "payload" ? [] : "",
        //                     "whatsapp_template_button_sub_type_field_option_id": null
        //                 }))
        //             }
        //         ]
        //     };

        //     const existingButtonIndex = prevState.whatsapp_template_data.whatsapp_template_button.findIndex(
        //         (button: any) => button.whatsapp_template_button_type_id == buttonTypeId
        //     );

        //     if (existingButtonIndex !== -1) {
        //         // If the Call to action button already exists, add the new sub-type data to it
        //         const updatedButtons = [...prevState.whatsapp_template_data.whatsapp_template_button];
        //         updatedButtons[existingButtonIndex].whatsapp_template_button_data.push(
        //             newButtonType.whatsapp_template_button_data[0]
        //         );

        //         return {
        //             ...prevState,
        //             whatsapp_template_data: {
        //                 ...prevState.whatsapp_template_data,
        //                 whatsapp_template_button: updatedButtons
        //             }
        //         };
        //     } else {
        //         // If the Call to action button does not exist, add it to the array
        //         return {
        //             ...prevState,
        //             whatsapp_template_data: {
        //                 ...prevState.whatsapp_template_data,
        //                 whatsapp_template_button: [
        //                     ...prevState.whatsapp_template_data.whatsapp_template_button,
        //                     newButtonType
        //                 ]
        //             }
        //         };
        //     }
        // });
        const btnType = getNewBtnType(buttonTypeId, subTypeId);
        setCreateTemplatePayload((prevState: any) => {
            return {
                ...prevState,
                whatsapp_template_data: {
                    ...prevState.whatsapp_template_data,
                    whatsapp_template_button: addButtonWithSubTypeGrouping(prevState.whatsapp_template_data.whatsapp_template_button, btnType, subTypeId)
                }
            };
        });

        if (isFlowButton(buttonTypeId) && !publishedFlowList) {
            getFlowListApi();
        }
    };

    const handleAddQuickReply = () => {
        const newQuickReply = {
            id: new Date().getTime(),
            value: ''
        }

        setQuickReply([...quickReply, newQuickReply])
    }

    const handleChangeCallField = (event: any, field: any, id: any) => {
        const temp = actions.map((ele: any) => {
            if (id == ele.id) {
                return {
                    ...ele,
                    [field]: event
                }
            }
            return ele
        })
        setActions(temp)
    }

    const handleChangeFieldVal = (value: number, ind: number, fieldIndex: number, btnTypeId: number, flagCarousel?: boolean) => {
        if (flagCarousel) {
            let val = [...createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_button[ind]?.whatsapp_template_button_data]
            let updatedVal = val.map((btn: any, i: number) => (i == fieldIndex) ? {
                ...btn,
                whatsapp_template_button_sub_type_id: value,
                whatsapp_template_button_sub_type_field_data: whatsappTemplateButtonGenericData?.find((btn) => btn.whatsapp_template_button_type_id == btnTypeId)?.whatsapp_template_button_sub_type_data?.find((subType: any) => subType?.whatsapp_template_button_sub_type_id == value)?.whatsapp_template_button_sub_type_field_data?.map((field: any) => ({
                    ...field,
                    "whatsapp_template_button_sub_type_field_value": "",
                    "whatsapp_template_button_sub_type_field_option_id": null
                }))
            } : btn);

            setCreateTemplatePayload((prevState: any) => ({
                ...prevState,
                whatsapp_template_data: {
                    ...prevState.whatsapp_template_data,
                    whatsapp_template_carousel: {
                        ...prevState.whatsapp_template_data.whatsapp_template_carousel,
                        whatsapp_template_carousel_card: prevState.whatsapp_template_data.whatsapp_template_carousel.whatsapp_template_carousel_card.map((cards: any) => {
                            return {
                                ...cards,
                                whatsapp_template_button: cards.whatsapp_template_button.map((btn: any, index: number) => index == ind ? { ...btn, whatsapp_template_button_data: updatedVal } : btn)
                            }
                        })
                    }
                },
            }));
        }
        else {
            let val = [...createTemplatePayload.whatsapp_template_data.whatsapp_template_button[ind]?.whatsapp_template_button_data]
            let updatedVal = val.map((btn: any, i: number) => (i == fieldIndex) ? {
                ...btn,
                whatsapp_template_button_sub_type_id: value,
                whatsapp_template_button_sub_type_name: whatsappTemplateButtonGenericData?.find((btn) => btn.whatsapp_template_button_type_id == btnTypeId)?.whatsapp_template_button_sub_type_data?.find((subType: any) => subType?.whatsapp_template_button_sub_type_id == value)?.whatsapp_template_button_sub_type_name,
                whatsapp_template_button_sub_type_field_data: whatsappTemplateButtonGenericData?.find((btn) => btn.whatsapp_template_button_type_id == btnTypeId)?.whatsapp_template_button_sub_type_data?.find((subType: any) => subType?.whatsapp_template_button_sub_type_id == value)?.whatsapp_template_button_sub_type_field_data?.map((field: any) => ({
                    ...field,
                    "whatsapp_template_button_sub_type_field_value": "",
                    "whatsapp_template_button_sub_type_field_option_id": null
                }))
            } : btn);

            setCreateTemplatePayload((prevState: any) => ({
                ...prevState,
                whatsapp_template_data: {
                    ...prevState.whatsapp_template_data,
                    whatsapp_template_button: prevState.whatsapp_template_data.whatsapp_template_button.map((btn: any, index: number) => index == ind ? { ...btn, whatsapp_template_button_data: updatedVal } : btn)
                },
            }));
        }

        if (flagCarousel) {
            carouselInvalidId?.map((carousels: any) => {
                if (carousels.inValidIds.includes(String(ind + fieldIndex))) {
                    setCarouselInvalidId((prevCarousels: any) =>
                        prevCarousels?.map((carousel: any) => {
                            if (carousel.index == carousels.index) {
                                return {
                                    ...carousel,
                                    inValidIds: carousel.inValidIds.filter((ele: any) => ele != String(ind + fieldIndex))
                                }
                            }
                            return carousel
                        })
                    )
                    inValidIdRefCarousel.current = inValidIdRefCarousel.current.map((refC) => {
                        if (refC.index == carousels.index) {
                            return {
                                ...refC,
                                inValids: refC.inValids.filter((ele: any) => ele != String(ind + fieldIndex))
                            }
                        }
                        return refC
                    })
                }
                if (carousels.inValidIds.includes(fieldIndex)) {
                    setCarouselInvalidId((prevCarousels: any) =>
                        prevCarousels?.map((carousel: any) => {
                            if (carousel.index == carousels.index) {
                                return {
                                    ...carousel,
                                    inValidIds: carousel.inValidIds.filter((ele: any) => ele != fieldIndex)
                                }
                            }
                            return carousel
                        })
                    )
                    inValidIdRefCarousel.current = inValidIdRefCarousel.current.map((refC) => {
                        if (refC.index == carousels.index) {
                            return {
                                ...refC,
                                inValids: refC.inValids.filter((ele: any) => ele != fieldIndex)
                            }
                        }
                        return refC
                    })
                }
            })
        }
        else {
            if (inValidId.includes(String(ind + fieldIndex))) {
                setInvalidId(inValidId.filter((ele: any) => ele != String(ind + fieldIndex)));
                inValidIdRef.current = inValidIdRef.current.filter((ele: any) => ele != String(ind + fieldIndex));
            }
            if (inValidId.includes(fieldIndex)) {
                setInvalidId(inValidId.filter((ele: any) => ele != fieldIndex));
                inValidIdRef.current = inValidIdRef.current.filter((ele: any) => ele != fieldIndex);
            }
        }
    }

    const handleDeleteQuickReply = (id: any) => {
        if (quickReply.length == 1) {
            setQuickReply(quickReply.map((action: any) => action.id == id ? { ...action, value: '' } : action))
        }
        else {
            setQuickReply(quickReply.filter((action: any) => action.id !== id))
        }
    }

    const checkIfFlowButtonIsExist = () => {
        const isFlowButtonExist = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.find((button) => isFlowButton(button?.whatsapp_template_button_type_id || 0))
        if (isFlowButtonExist) {
            return true;
        }
        return false;
    }

    const handleSubmitTemplate = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))

        let payload: any = { ...createTemplatePayload };
        const headerType = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_type_name;
        if (headerType?.toLowerCase() === "none") {
            if (payload.whatsapp_template_data.whatsapp_template_header && payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data && payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data.length > 0) {
                payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_data_id = null;
            }
            else {
                payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data = [{
                    whatsapp_template_header_data_value: "",
                    whatsapp_template_header_data_id: 0,
                    whatsapp_template_header_data_google_storage_id: 0,
                    whatsapp_template_header_variable_data: []
                }];
            }
            payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_id = null;
            payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_type_id = null;
            setExistingHeaderTemplateVariableData(null);
        }


        let response
        //this is to add static - variable data
        if (headerType?.toLowerCase() === "image" || headerType?.toLowerCase() === "video" || headerType?.toLowerCase() === "document") {

            let dynamic_variable_id = null, unique_id = 0, history_id = null, added_by_change_log_id = 0, variable_flag_deleted = false;
            if (existingHeaderTemplateVariableData && existingHeaderTemplateVariableData.length > 0 && existingHeaderTemplateVariableData[0]) {
                dynamic_variable_id = "whatsapp_template_dynamic_variable_id" in existingHeaderTemplateVariableData[0] ? existingHeaderTemplateVariableData[0].whatsapp_template_dynamic_variable_id : 0;
                unique_id = "whatsapp_template_dynamic_variable_unique_id" in existingHeaderTemplateVariableData[0] ? existingHeaderTemplateVariableData[0].whatsapp_template_dynamic_variable_unique_id : 0;
                history_id = "history_id" in existingHeaderTemplateVariableData[0] ? existingHeaderTemplateVariableData[0].history_id : null;
            }

            payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data = [{
                whatsapp_template_dynamic_variable_id: createTemplatePayload.whatsapp_template_id ? dynamic_variable_id : 0,
                // whatsapp_template_dynamic_variable_type_id: whastappTemplateHeaderTypes?.find((hType) => hType.whatsapp_template_header_type_name == headerType)?.whatsapp_template_header_type_id,
                whatsapp_template_dynamic_variable_type_id: whatsappTemplateDynamicVarTypes?.find((varType) => varType?.whatsapp_template_dynamic_variable_type_name?.toLowerCase() == 'header')?.whatsapp_template_dynamic_variable_type_id,
                whatsapp_template_dynamic_variable_unique_id: createTemplatePayload.whatsapp_template_id ? unique_id : 0,
                whatsapp_template_dynamic_variable_key: payload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data?.[0]?.whatsapp_template_dynamic_variable_key ?? `{{Header${headerType}}}`,
                whatsapp_template_dynamic_variable_sample_value: payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_data_value || payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data?.[0]?.whatsapp_template_dynamic_variable_sample_value,
                history_id: createTemplatePayload.whatsapp_template_id ? history_id : null,
                added_by_change_log_id: createTemplatePayload.whatsapp_template_id ? added_by_change_log_id : 0,
                whatsapp_template_dynamic_variable_flag_deleted: createTemplatePayload.whatsapp_template_id ? variable_flag_deleted : false,
                whatsapp_template_id: createTemplatePayload.whatsapp_template_id ? payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data?.[0]?.whatsapp_template_id : 0,
                flag_header: createTemplatePayload.whatsapp_template_id ? payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data?.[0]?.flag_header : null,
                flag_button: createTemplatePayload.whatsapp_template_id ? payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data?.[0]?.flag_button : null,
                whatsapp_template_dynamic_variable_type_name: "Header"
            }]
        } else if (headerType?.toLowerCase() === "text" && payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data.length > 0) {
            let dynamic_variable_id = null;
            if (existingHeaderTemplateVariableData && existingHeaderTemplateVariableData.length > 0 && existingHeaderTemplateVariableData[0]) {
                dynamic_variable_id = "whatsapp_template_dynamic_variable_id" in existingHeaderTemplateVariableData[0] ? existingHeaderTemplateVariableData[0].whatsapp_template_dynamic_variable_id : null;
            }
            payload.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data[0].whatsapp_template_header_variable_data[0].whatsapp_template_dynamic_variable_id = dynamic_variable_id;
        }
        if (createTemplatePayload.whatsapp_template_data.whatsapp_template_footer.whatsapp_template_footer_value === "") {
            payload.whatsapp_template_data.whatsapp_template_footer.whatsapp_template_footer_id = 0;
        }

        if (checkIfFlowButtonIsExist()) {
            payload.whatsapp_template_flag_flow = true;
        } else {
            payload.whatsapp_template_flag_flow = false;
        }

        if(Number(payload?.whatsapp_template_data?.whatsapp_template_category_id) === getTemplateCategoryId(TEMPLATE_CATEGORY?.AUTHENTICATION, templateLibraryCategoryList ?? [])) {
            delete payload?.whatsapp_template_data?.whatsapp_template_header;
        }

        if (createTemplatePayload.whatsapp_template_id) {
            response = await agent.updateWhatsappTemplate.put(payload)
        } else {
            if(!payload.meta_integration_whatsapp_id) {
                payload.meta_integration_whatsapp_id = Number(id);
            }
            response = await agent.createWhatsappTemplate.post(payload)
        }
        if (response.status) {
            showSuccess(createTemplatePayload.whatsapp_template_id ? "Template Updated Successfully!" : "Template Created Successfully!")
            updateCreateTemplatepayload(response?.data[0])
            navigate(`/channels/viewintegration/whatsapp/templatemessages?id=${id}`)
        } else {
            handleError(response);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const handleSubmitCarouselTemplate = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))

        let payload = { ...createTemplatePayload };
        payload.whatsapp_template_data.whatsapp_template_header = {} as createWhatsappTemplateHeader;
        payload.whatsapp_template_data.whatsapp_template_body = {} as createWhatsappTemplateBody;
        payload.whatsapp_template_data.whatsapp_template_button = [];
        payload.whatsapp_template_data.whatsapp_template_footer = {} as createWhatsappTemplateFooter;

        const headerType = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_header?.whatsapp_template_header_type_name;
        let response
        if (headerType?.toLowerCase() === "image" || headerType?.toLowerCase() === "video") {

            let dynamic_variable_id = null, unique_id = 0, history_id = null, added_by_change_log_id = 0, variable_flag_deleted = false;
            // if (existingHeaderTemplateVariableData && existingHeaderTemplateVariableData.length > 0 && existingHeaderTemplateVariableData[0]) {
            //     dynamic_variable_id = "whatsapp_template_dynamic_variable_id" in existingHeaderTemplateVariableData[0] ? existingHeaderTemplateVariableData[0].whatsapp_template_dynamic_variable_id : 0;
            //     unique_id = "whatsapp_template_dynamic_variable_unique_id" in existingHeaderTemplateVariableData[0] ? existingHeaderTemplateVariableData[0].whatsapp_template_dynamic_variable_unique_id : 0;
            //     history_id = "history_id" in existingHeaderTemplateVariableData[0] ? existingHeaderTemplateVariableData[0].history_id : null;
            // }

            payload.whatsapp_template_data.whatsapp_template_carousel.whatsapp_template_carousel_card = payload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.map((cards) => {
                return {
                    ...cards,
                    whatsapp_template_header: {
                        ...cards.whatsapp_template_header,
                        whatsapp_template_header_data: cards.whatsapp_template_header?.whatsapp_template_header_data?.map((headerData) => {
                            return {
                                ...headerData,
                                whatsapp_template_header_variable_data: [{
                                    // whatsapp_template_dynamic_variable_id: createTemplatePayload.whatsapp_template_id ? dynamic_variable_id : 0,
                                    whatsapp_template_dynamic_variable_id: 0,
                                    whatsapp_template_dynamic_variable_key: `{{Header${headerType}}}`,
                                    whatsapp_template_dynamic_variable_sample_value: headerData?.whatsapp_template_header_data_value
                                }]
                            }
                        })
                    },
                }
            })
        }

        // console.log(payload, "payload to submit")
        if (createTemplatePayload.whatsapp_template_id) {
            response = await agent.updateWhatsappTemplate.put(payload)
        }
        else {
            response = await agent.createWhatsappTemplate.post(payload)
        }
        if (response.status && response?.data) {
            showSuccess(createTemplatePayload.whatsapp_template_id ? "Template Updated Successfully!" : "Template Created Successfully!")
            updateCreateTemplatepayload(response?.data[0])
            navigate(`/channels/viewintegration/whatsapp/templatemessages?id=${id}`)
        }
        else {
            handleError(response);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const checkIfHeaderDataIsFillOrNot = () => {
        const headerType = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_type_name;
        if (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header &&
            (headerType?.toLowerCase() === "none"
                ||
                (headerType?.toLowerCase() === "text" &&
                    createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_value.trim().length > 0 &&
                    createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data.filter((variable) => variable.whatsapp_template_dynamic_variable_sample_value.trim() == "").length === 0
                )
                ||
                ((headerType?.toLowerCase() === "image" || headerType?.toLowerCase() === "video" || headerType?.toLowerCase() === "document") && files.length > 0)
            )) {
            return true;
        }
        if(isAuthenticationTemplate) {
            return true;
        }
        return false;
    }

    const checkIfHeaderDataIsFillOrNotCarousel = () => {
        const headerType = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_header?.whatsapp_template_header_type_name;
        if (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_header) {
            if ((headerType?.toLowerCase() === "image" || headerType?.toLowerCase() === "video") && carouselFiles?.every((cFiles: any) => cFiles?.carousels?.length > 0)) {
                return true;
            }
        }
        return false;
    }

    const handleSubmitTemplateDisabled = () => {

        //Global condition to check for disable
        if(!createTemplatePayload?.whatsapp_template_flag_interactive_message && !createTemplatePayload?.whatsapp_template_data?.whatsapp_template_category_id) {
            return true;
        }
        if (createTemplatePayload.whatsapp_template_data.whatsapp_template_name.trim().length === 0) {
            return true;
        }

        // Language Condition for normal template
        if (!createTemplatePayload?.whatsapp_template_flag_interactive_message && createTemplatePayload?.whatsapp_template_data?.whatsapp_language_id == 0) {
            return true;
        }

        //Condition to check for disable when template type is basic
        if (isBasicTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) &&
            (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_body?.whatsapp_template_body_value?.trim().length === 0 ||
                // createTemplatePayload.whatsapp_template_data.whatsapp_template_body.whatsapp_template_body_description.trim().length === 0 ||
                createTemplatePayload?.whatsapp_template_data?.whatsapp_template_body?.whatsapp_template_body_variable_data?.filter((data) => data?.whatsapp_template_dynamic_variable_sample_value?.trim() == "").length != 0 ||
                checkFlagError("both") || 
                !checkTypeOfVariableValidation('both') ||
                !checkIfHeaderDataIsFillOrNot() ||
                inValidId.length > 0
            )
        ) {
            return true
        }

        // Minimum button and Interactive Type condition for interactive message template.
        if (createTemplatePayload?.whatsapp_template_flag_interactive_message) {
            if (!createTemplatePayload?.interactive_type_id ||
                createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.length < getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList)?.minimum_button_count) {
                return true;
            }
            if (isInteractiveTypeMessageList(createTemplatePayload?.interactive_type_id, interactiveTypeList)) {
                if (createTemplatePayload?.interactive_list_button_text?.trim()?.length == 0) {
                    return true;
                }
            }
        }

        //Condition to check for disable when template type is basic
        if (isBasicTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)) {
            for (const button of (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button ?? [])) {

                for (const buttonData of (button?.whatsapp_template_button_data ?? [])) {
                    for (const fieldData of (buttonData?.whatsapp_template_button_sub_type_field_data ?? [])) {
                        if (fieldData?.field_static_value_flag === true && !createTemplatePayload?.whatsapp_template_id) {
                            return false;
                        }
                        if (fieldData?.field_name.toLowerCase() === "website url" && fieldData?.whatsapp_template_button_field_data_variable && fieldData?.whatsapp_template_button_field_data_variable.length > 0) {
                            if (fieldData?.whatsapp_template_button_field_data_variable?.[0]?.whatsapp_template_dynamic_variable_sample_value.trim().length === 0) {
                                return true;
                            }
                        }
                        if (fieldData?.field_type?.toLowerCase() == "textfield" && (!fieldData?.whatsapp_template_button_sub_type_field_value || (typeof fieldData?.whatsapp_template_button_sub_type_field_value == "string" && fieldData?.whatsapp_template_button_sub_type_field_value.trim() === ''))
                        ) {
                            if (fieldData?.field_name.toLowerCase() != "button description") {
                                return true;
                            }
                        }
                        if (fieldData?.field_name.toLowerCase() == "payload" && (typeof fieldData?.whatsapp_template_button_sub_type_field_value == "object" && fieldData?.whatsapp_template_button_sub_type_field_value.filter((values: any) => values.payload_key.trim() == "" || values.payload_key_value.trim() == "")?.length > 0)
                        ) {
                            return true;
                        }
                        if (fieldData?.field_type?.toLowerCase() == "autocomplete") {
                            if (isFlowButton(button?.whatsapp_template_button_type_id || 0)) {
                                if (!fieldData?.whatsapp_template_button_sub_type_field_value) {
                                    return true;
                                }
                            } else {
                                if (fieldData?.whatsapp_template_button_sub_type_field_option_id == null || Number(fieldData?.whatsapp_template_button_sub_type_field_option_id) === 0) {
                                    return true;
                                }
                            }
                        }
                        // if (fieldData.field_type.toLowerCase() == "autocomplete" && (fieldData.whatsapp_template_button_sub_type_field_option_id == null || Number(fieldData.whatsapp_template_button_sub_type_field_option_id) === 0)
                        // ) {
                        //     return true;
                        // }
                    }
                }
            }
        }


        //Condition to check for disable when template type is carousel
        if (isCarouselTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) &&
            (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_header?.trim()?.length === 0 ||
                checkFlagErrorCarousel("header") ||
                checkBodyValueVariableCard() ||
                checkButtonVariableCard() ||
                !checkHeaderCard() ||
                // !checkBodyDescriptionCards() ||  Not Required Body Description
                !checkBodyValueCards() ||
                !checkBodyVariableCard() ||
                !checkButtonLengthCard() ||
                !checkIfHeaderDataIsFillOrNotCarousel() ||
                carouselInvalidId.find((ids: any) => ids.inValidIds?.length > 0)
                || existingPayloadKey?.length > 0
            )
        ) {
            return true
        }

        if (invalidPayloadObjectId?.length > 0) return true; // If Flow Payload Object is not valid json

        //if every condition fails return false

        if(createTemplatePayload?.whatsapp_template_id){
            if(JSON.stringify(createTemplatePayload) == JSON.stringify(existingTemplateData)){
                return true;
            }
            if(areBodyVariablesModified(createTemplatePayload, existingTemplateData) || areHeaderVariablesModified(createTemplatePayload, existingTemplateData)){
                return true;
            }
        }
        return false;
    }

    const isValidWebsiteURLWithVariable = (url: string) => {
        const isValidURL = validator.isURL(url, { require_protocol: true });
        if (!isValidURL) return false;

        const variableAtEndPattern = /\{\{\d+\}\}$/;
        if (!variableAtEndPattern.test(url)) return false;

        // 3. Only one variable allowed — count all `{{...}}` patterns
        const allVariables = url.match(/\{\{\d+\}\}/g) || [];
        if (allVariables.length !== 1) return false;

        return true;
    }

    const handleValidWebsite = (website_value: any, field: any, index: any, cardIndex?: number) => {
        if (cardIndex || cardIndex == 0) {
            let cardData = inValidIdRefCarousel?.current?.find((ids: any) => ids.index == cardIndex)
            if (field === "Website URL" && website_value.trim().length > 0) {
                let temp = validator.isURL(website_value, { require_protocol: true })
                if (temp) {
                    if (cardData) {
                        if (cardData.inValids?.includes(index)) {
                            setCarouselInvalidId((prevCarousels: any) =>
                                prevCarousels?.map((carousel: any) => {
                                    if (carousel.index == cardData.index) {
                                        return {
                                            ...carousel,
                                            inValidIds: carousel.inValidIds.filter((ele: any) => ele !== index)
                                        }
                                    }
                                    return carousel
                                })
                            )
                            inValidIdRefCarousel.current = inValidIdRefCarousel.current.map((refC) => {
                                if (refC.index == cardData.index) {
                                    return {
                                        ...refC,
                                        inValids: refC.inValids.filter((ele: any) => ele !== index)
                                    }
                                }
                                return refC
                            })
                        }
                    }
                } else {
                    if (cardData) {
                        if (cardData.inValids?.includes(index)) { }
                        else {
                            setCarouselInvalidId((prevCarousels: any) =>
                                prevCarousels?.map((carousel: any) => {
                                    if (carousel.index == cardData.index) {
                                        return {
                                            ...carousel,
                                            inValidIds: carousel.inValidIds && carousel.inValidIds.includes(index) ? carousel.inValidIds : [...carousel.inValidIds, index]
                                        }
                                    }
                                    return carousel
                                })
                            )
                            inValidIdRefCarousel.current = inValidIdRefCarousel.current.map((refC) => {
                                if (refC.index == cardData.index) {
                                    return {
                                        ...refC,
                                        inValids: refC.inValids && refC.inValids.includes(index) ? refC.inValids : [...refC.inValids, index]
                                    }
                                }
                                return refC
                            })
                        }
                    }
                }
            } else if (field === "Website URL" && website_value.trim().length == 0) {
                if (cardData) {
                    if (cardData?.inValids?.includes(index)) {
                        setCarouselInvalidId((prevCarousels: any) =>
                            prevCarousels.map((carousel: any) => {
                                if (carousel?.index == cardData?.index) {
                                    return {
                                        ...carousel,
                                        inValidIds: carousel?.inValidIds?.filter((ele: any) => ele !== index)
                                    }
                                }
                                return carousel
                            })
                        )
                        inValidIdRefCarousel.current = inValidIdRefCarousel.current.map((refC) => {
                            if (refC?.index == cardData?.index) {
                                return {
                                    ...refC,
                                    inValids: refC?.inValids?.filter((ele: any) => ele !== index)
                                }
                            }
                            return refC
                        })
                    }
                }
            }
        }
        else {
            if (field === "Website URL" && website_value.trim().length > 0) {
                let temp = validator.isURL(website_value, { require_protocol: true })
                if (temp) {
                    if (inValidIdRef.current.includes(index)) {
                        setInvalidId(inValidIdRef.current.filter((ele: any) => ele !== index))
                        inValidIdRef.current = inValidIdRef.current.filter((ele: any) => ele !== index);
                    } else {
                    }
                } else {
                    if (inValidIdRef.current.includes(index)) {
                    } else {
                        setInvalidId((prev: any) => [...prev, index])
                        inValidIdRef.current = [...inValidIdRef.current, index];
                    }
                }
            } else if (field === "Website URL" && website_value.trim().length == 0) {
                if (inValidIdRef.current.includes(index)) {
                    setInvalidId(inValidIdRef.current.filter((ele: any) => ele !== index))
                    inValidIdRef.current = inValidIdRef.current.filter((ele: any) => ele !== index);
                } else {
                }
            }
        }
    }

    const autoCompleteValue = (genericData: any, btnTypeId: number, subTypeId: number) => {
        if (genericData?.field_static_value_flag) {
            return genericData?.field_static_value;
        }
        if (isFlowButton(btnTypeId)) {
            const flow = publishedFlowList?.find((flow: any) => flow?.whatsapp_flow_id == genericData?.whatsapp_template_button_sub_type_field_value);
            return flow || null;
        }
        const returnVal = whatsappTemplateButtonGenericData?.find((btn) => btn.whatsapp_template_button_type_id == btnTypeId)?.
            whatsapp_template_button_sub_type_data?.find((subType) => subType?.whatsapp_template_button_sub_type_id == subTypeId)?.
            whatsapp_template_button_sub_type_field_data?.find((field) => field?.whatsapp_template_button_sub_type_field_id == genericData?.whatsapp_template_button_sub_type_field_id)?.
            field_option_data.find((option) => option?.field_option_id == genericData?.whatsapp_template_button_sub_type_field_option_id) ?? null;
        return returnVal;
    }

    const setPayloadOnChangeOfGetInput = (whatsappTemplateButtonIndex: number, inputTypeName: string, field_name: string, value: any, btnTypeId: number, whatsappTemplateButtonDataIndex: number, subFieldIndex: number) => {
        // old code before structure change
        // setCreateTemplatePayload((prevState: any) => ({
        //     ...prevState,
        //     whatsapp_template_data: {
        //         ...prevState.whatsapp_template_data,
        //         whatsapp_template_button: prevState.whatsapp_template_data.whatsapp_template_button.map((btn: any, btnIndex: any) => {
        //             if (btn.whatsapp_template_button_type_id === btnTypeId) {
        //                 return {
        //                     ...btn,
        //                     whatsapp_template_button_data: btn.whatsapp_template_button_data.map((buttonData: any, buttonDataIndex: any) => {
        //                         if (buttonDataIndex === finalIndex) {
        //                             return {
        //                                 ...buttonData,
        //                                 whatsapp_template_button_sub_type_field_data: buttonData.whatsapp_template_button_sub_type_field_data.map((field: any, fieldIndex: any) => {
        //                                     if (fieldIndex === index) {
        //                                         return {
        //                                             ...field,
        //                                             ...(inputTypeName === "Autocomplete" ?
        //                                                 {
        //                                                     whatsapp_template_button_sub_type_field_option_id: value ? value.field_option_id : null,
        //                                                 } :
        //                                                 {
        //                                                     whatsapp_template_button_sub_type_field_value: (field_name === "Phone number") ? value.replace(/[^0-9_]/g, '') : value,
        //                                                 }
        //                                             ),

        //                                         };
        //                                     }
        //                                     // return { ...field, whatsapp_template_button_field_data_variable: [] };
        //                                     return { ...field };
        //                                 })
        //                             };
        //                         }
        //                         return buttonData;
        //                     })
        //                 };
        //             }
        //             return btn;
        //         })
        //     }
        // }));
        setCreateTemplatePayload((prevState: any) => ({
            ...prevState,
            whatsapp_template_data: {
                ...prevState.whatsapp_template_data,
                whatsapp_template_button: prevState.whatsapp_template_data.whatsapp_template_button.map((btn: any, btnIndex: any) => {
                    if (btnIndex === whatsappTemplateButtonIndex) {
                        return {
                            ...btn,
                            whatsapp_template_button_data: btn?.whatsapp_template_button_data?.map((buttonData: any, buttonDataIndex: any) => {
                                if (buttonDataIndex === whatsappTemplateButtonDataIndex) {
                                    return {
                                        ...buttonData,
                                        whatsapp_template_button_sub_type_field_data: buttonData.whatsapp_template_button_sub_type_field_data.map((field: any, fieldIndex: any) => {
                                            if (field.whatsapp_template_button_sub_type_field_id === subFieldIndex) {
                                                return {
                                                    ...field,
                                                    ...(inputTypeName === "Autocomplete" ?
                                                        value ?
                                                            "whatsapp_flow_id" in value ?
                                                                {
                                                                    whatsapp_template_button_sub_type_field_value: value?.whatsapp_flow_id || null,
                                                                }
                                                                :
                                                                {
                                                                    whatsapp_template_button_sub_type_field_option_id: value ? value.field_option_id : null,
                                                                }
                                                            :
                                                            {
                                                                whatsapp_template_button_sub_type_field_value: null,
                                                                whatsapp_template_button_sub_type_field_option_id: null,
                                                            }
                                                        :
                                                        {
                                                            whatsapp_template_button_sub_type_field_value: (field_name === "Phone number") ? value.replace(/[^0-9_]/g, '') : value,
                                                        }
                                                    ),

                                                };
                                            }
                                            // return { ...field, whatsapp_template_button_field_data_variable: [] };
                                            return { ...field };
                                        })
                                    };
                                }
                                return buttonData;
                            })
                        };
                    }
                    return btn;
                })
            }
        }));
    }

    const setCarouselPayloadOnChangeOfGetInput = (whatsappTemplateButtonIndex: number, inputTypeName: string, field_name: string, value: any, btnTypeId: number, whatsappTemplateButtonDataIndex: number, subFieldIndex: number, cardIndex: number) => {
        // old code before structure change
        // setCreateTemplatePayload((prevState: any) => ({
        //     ...prevState,
        //     whatsapp_template_data: {
        //         ...prevState.whatsapp_template_data,
        //         whatsapp_template_carousel: {
        //             ...prevState.whatsapp_template_data.whatsapp_template_carousel,
        //             whatsapp_template_carousel_card: prevState.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card.map((card: any, ind: number) => {
        //                 if (ind == cardIndex) {
        //                     return {
        //                         ...card,
        //                         whatsapp_template_button: card.whatsapp_template_button.map((btn: any, btnIndex: any) => {
        //                             if (btn.whatsapp_template_button_type_id === btnTypeId) {
        //                                 return {
        //                                     ...btn,
        //                                     whatsapp_template_button_data: btn.whatsapp_template_button_data.map((buttonData: any, buttonDataIndex: any) => {
        //                                         if (buttonDataIndex === finalIndex) {
        //                                             return {
        //                                                 ...buttonData,
        //                                                 whatsapp_template_button_sub_type_field_data: buttonData.whatsapp_template_button_sub_type_field_data.map((field: any, fieldIndex: any) => {
        //                                                     if (fieldIndex === index) {
        //                                                         return {
        //                                                             ...field,
        //                                                             ...(inputTypeName === "Autocomplete" ?
        //                                                                 {
        //                                                                     whatsapp_template_button_sub_type_field_option_id: value ? value.field_option_id : null,
        //                                                                 } :
        //                                                                 {
        //                                                                     whatsapp_template_button_sub_type_field_value: (field_name === "Phone number") ? value.replace(/[^0-9_]/g, '') : value,
        //                                                                 }
        //                                                             ),

        //                                                         };
        //                                                     }
        //                                                     // return { ...field, whatsapp_template_button_field_data_variable: [] };
        //                                                     return { ...field };
        //                                                 })
        //                                             };
        //                                         }
        //                                         return buttonData;
        //                                     })
        //                                 };
        //                             }
        //                             return btn;
        //                         })
        //                     }
        //                 }
        //                 return card;
        //             })
        //         }
        //     }
        // }));
        setCreateTemplatePayload((prevState: any) => ({
            ...prevState,
            whatsapp_template_data: {
                ...prevState.whatsapp_template_data,
                whatsapp_template_carousel: {
                    ...prevState.whatsapp_template_data.whatsapp_template_carousel,
                    whatsapp_template_carousel_card: prevState.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card.map((card: any, ind: number) => {
                        if (ind == cardIndex) {
                            return {
                                ...card,
                                whatsapp_template_button: card.whatsapp_template_button.map((btn: any, btnIndex: any) => {
                                    if (btnIndex === whatsappTemplateButtonIndex) {
                                        return {
                                            ...btn,
                                            whatsapp_template_button_data: btn?.whatsapp_template_button_data?.map((buttonData: any, buttonDataIndex: any) => {
                                                if (buttonDataIndex === whatsappTemplateButtonDataIndex) {
                                                    return {
                                                        ...buttonData,
                                                        whatsapp_template_button_sub_type_field_data: buttonData.whatsapp_template_button_sub_type_field_data.map((field: any, fieldIndex: any) => {
                                                            if (field.whatsapp_template_button_sub_type_field_id === subFieldIndex) {
                                                                return {
                                                                    ...field,
                                                                    ...(inputTypeName === "Autocomplete" ?
                                                                        {
                                                                            whatsapp_template_button_sub_type_field_option_id: value ? value.field_option_id : null,
                                                                        } :
                                                                        {
                                                                            whatsapp_template_button_sub_type_field_value: (field_name === "Phone number") ? value.replace(/[^0-9_]/g, '') : value,
                                                                        }
                                                                    ),

                                                                };
                                                            }
                                                            // return { ...field, whatsapp_template_button_field_data_variable: [] };
                                                            return { ...field };
                                                        })
                                                    };
                                                }
                                                return buttonData;
                                            })
                                        };
                                    }
                                    return btn;
                                })
                            }
                        }
                        return card;
                    })
                }
            }
        }));
    }

    const setOnChangeOfPayloadObject = (field_name: string, value: any, btnTypeId: number, finalIndex: number, payloadIndex: number, subTypeIndex: number, whatsappTemplateButtonIndex: number, flagRemove?: boolean) => {
        setCreateTemplatePayload((prevState: any) => ({
            ...prevState,
            whatsapp_template_data: {
                ...prevState.whatsapp_template_data,
                whatsapp_template_button: prevState.whatsapp_template_data.whatsapp_template_button.map((btn: any, btnIndex: any) => {
                    if (btn.whatsapp_template_button_type_id === btnTypeId && btnIndex == whatsappTemplateButtonIndex) {
                        return {
                            ...btn,
                            whatsapp_template_button_data: btn?.whatsapp_template_button_data?.map((buttonData: any, buttonDataIndex: any) => {
                                if (buttonDataIndex === finalIndex) {
                                    return {
                                        ...buttonData,
                                        whatsapp_template_button_sub_type_field_data: buttonData.whatsapp_template_button_sub_type_field_data.map((field: any, fieldIndex: any) => {
                                            if (field.whatsapp_template_button_sub_type_field_id === subTypeIndex) {
                                                return {
                                                    ...field,
                                                    whatsapp_template_button_sub_type_field_value: flagRemove ?
                                                        field.whatsapp_template_button_sub_type_field_value.filter((payload: any) =>
                                                            payload.payload_key_id ? payload.payload_key_id != payloadIndex : payload.whatsapp_template_button_field_data_id != payloadIndex
                                                        )
                                                        :
                                                        field.whatsapp_template_button_sub_type_field_value.map((payload: any) =>
                                                            payload.payload_key_id ? payload.payload_key_id == payloadIndex
                                                                ? { ...payload, [field_name]: value }
                                                                : payload
                                                                :
                                                                payload.whatsapp_template_button_field_data_id == payloadIndex
                                                                    ? { ...payload, [field_name]: value }
                                                                    : payload
                                                        )
                                                };
                                            }
                                            return field;
                                        })
                                    };
                                }
                                return buttonData;
                            })
                        };
                    }
                    return btn;
                })
            }
        }));
    }

    const setOnChangeOfPayloadObjectCarousel = (field_name: string, value: any, btnTypeId: number, finalIndex: number, payloadIndex: number, subTypeIndex: number, cardIndex: number, whatsappTemplateButtonIndex: number, flagRemove?: boolean) => {
        setCreateTemplatePayload((prevState: any) => ({
            ...prevState,
            whatsapp_template_data: {
                ...prevState.whatsapp_template_data,
                whatsapp_template_carousel: {
                    ...prevState.whatsapp_template_data.whatsapp_template_carousel,
                    whatsapp_template_carousel_card: prevState.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card.map((card: any, ind: number) => {
                        if (ind == cardIndex || field_name?.toLowerCase() == "payload_key" || flagRemove) {
                            return {
                                ...card,
                                whatsapp_template_button: card.whatsapp_template_button.map((btn: any, btnIndex: any) => {
                                    if (btn.whatsapp_template_button_type_id === btnTypeId && btnIndex == whatsappTemplateButtonIndex) {
                                        return {
                                            ...btn,
                                            whatsapp_template_button_data: btn?.whatsapp_template_button_data?.map((buttonData: any, buttonDataIndex: any) => {
                                                if (buttonDataIndex === finalIndex) {
                                                    return {
                                                        ...buttonData,
                                                        whatsapp_template_button_sub_type_field_data: buttonData.whatsapp_template_button_sub_type_field_data.map((field: any, fieldIndex: any) => {
                                                            if (field.whatsapp_template_button_sub_type_field_id === subTypeIndex) {
                                                                return {
                                                                    ...field,
                                                                    whatsapp_template_button_sub_type_field_value: flagRemove ?
                                                                        (Array.isArray(field.whatsapp_template_button_sub_type_field_value) ? field.whatsapp_template_button_sub_type_field_value : JSON.parse(field.whatsapp_template_button_sub_type_field_value))?.filter((payload: any) =>
                                                                            payload.payload_key_id ? payload.payload_key_id != payloadIndex : payload.whatsapp_template_button_field_data_id != payloadIndex
                                                                        )
                                                                        :
                                                                        field.whatsapp_template_button_sub_type_field_value.map((payload: any) =>
                                                                            payload.payload_key_id ? payload.payload_key_id == payloadIndex
                                                                                ? { ...payload, [field_name]: value }
                                                                                : payload
                                                                                :
                                                                                payload.whatsapp_template_button_field_data_id == payloadIndex
                                                                                    ? { ...payload, [field_name]: value }
                                                                                    : payload
                                                                        )
                                                                };
                                                            }
                                                            return field;
                                                        })
                                                    };
                                                }
                                                return buttonData;
                                            })
                                        };
                                    }
                                    return btn;
                                })
                            }
                        }
                        return card;
                    })
                }
            }
        }));

        if (field_name == "payload_key") {
            const keyOccurrences: Record<
                string,
                { index: number; whatsappTemplateButtonIndex: number }[]
            > = {};

            const duplicateKeysWithIndexes: {
                key: string;
                index: number;
                whatsappTemplateButtonIndex: number;
            }[] = [];

            createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_button?.forEach((btn, index) => {
                if (btn.whatsapp_template_button_type_id == btnTypeId && index == whatsappTemplateButtonIndex) {

                    btn?.whatsapp_template_button_data?.forEach((btnData: any, buttonDataIndex: number) => {
                        if (buttonDataIndex === finalIndex) {
                            btnData?.whatsapp_template_button_sub_type_field_data?.forEach((subType: any) => {
                                if (subType.field_name?.toLowerCase() === "payload" && subType.whatsapp_template_button_sub_type_field_id === subTypeIndex) {
                                    if (Array.isArray(subType.whatsapp_template_button_sub_type_field_value)) {
                                        subType.whatsapp_template_button_sub_type_field_value.forEach((payload: any, i: number) => {
                                            const key = i == cardIndex ? value : payload?.payload_key;
                                            if (key) {
                                                if (!keyOccurrences[key]) {
                                                    keyOccurrences[key] = [];
                                                }
                                                // keyOccurrences[key].push(i);
                                                keyOccurrences[key].push({
                                                    index: i,
                                                    whatsappTemplateButtonIndex: whatsappTemplateButtonIndex,
                                                });
                                            }
                                        });

                                        // Now extract duplicates
                                        Object.entries(keyOccurrences).forEach(([key, indexes]) => {
                                            if (indexes.length > 1) {
                                                indexes.forEach(({ index, whatsappTemplateButtonIndex }) => {
                                                    duplicateKeysWithIndexes.push({ key, index, whatsappTemplateButtonIndex });
                                                });
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    })

                }
            });

            let payloadKeys = existingPayloadKey?.filter((payload: any) => payload?.whatsappTemplateButtonIndex != whatsappTemplateButtonIndex);
            setExistingPayloadKey((prev: any) => ([...payloadKeys, ...duplicateKeysWithIndexes]))
        }
        if (flagRemove) {
            let otherPayloadKeys = existingPayloadKey?.filter((payload: any) => payload?.whatsappTemplateButtonIndex != whatsappTemplateButtonIndex);
            let currentButtonsPyloadKeys = existingPayloadKey?.filter((payload: any) => payload?.whatsappTemplateButtonIndex == whatsappTemplateButtonIndex);

            setExistingPayloadKey((prev: any) => [...otherPayloadKeys, ...currentButtonsPyloadKeys?.filter((payload: any) => payload.key != value)]);
        }
    }

    const getNewPayloadObjectWithUpdatedPayloadKeyId = (field: any) => {
        const existedPayloads = field?.whatsapp_template_button_sub_type_field_value?.map((subType: any, ind: number) => {
            return {
                ...subType,
                payload_key_id: ind,
            }
        });
        return [...existedPayloads,
        {
            payload_key_id: field.whatsapp_template_button_field_data_id ? field.whatsapp_template_button_field_data_id
                : field.whatsapp_template_button_sub_type_field_value.length || 0, payload_key: "", payload_key_value: ""
        }
        ];
    }

    const handleAddPayloadData = (btnTypeId: number, finalIndex: number, index: number, whatsappTemplateButtonIndex: number) => {
        setCreateTemplatePayload((prevState: any) => ({
            ...prevState,
            whatsapp_template_data: {
                ...prevState.whatsapp_template_data,
                whatsapp_template_button: prevState.whatsapp_template_data.whatsapp_template_button.map((btn: any, btnIndex: any) => {
                    if (btn.whatsapp_template_button_type_id === btnTypeId && btnIndex == whatsappTemplateButtonIndex) {
                        return {
                            ...btn,
                            whatsapp_template_button_data: btn?.whatsapp_template_button_data?.map((buttonData: any, buttonDataIndex: any) => {
                                if (buttonDataIndex === finalIndex) {
                                    return {
                                        ...buttonData,
                                        whatsapp_template_button_sub_type_field_data: buttonData.whatsapp_template_button_sub_type_field_data.map((field: any, fieldIndex: any) => {
                                            if (field.whatsapp_template_button_sub_type_field_id === index) {
                                                return {
                                                    ...field,
                                                    // whatsapp_template_button_sub_type_field_value: [...field.whatsapp_template_button_sub_type_field_value, 
                                                    //     { payload_key_id: field.whatsapp_template_button_field_data_id ? field.whatsapp_template_button_field_data_id 
                                                    //                         : field.whatsapp_template_button_sub_type_field_value.length || 0, payload_key: "", payload_key_value: "" }]
                                                    whatsapp_template_button_sub_type_field_value: getNewPayloadObjectWithUpdatedPayloadKeyId(field),
                                                };
                                            }
                                            // return { ...field, whatsapp_template_button_field_data_variable: [] };
                                            return { ...field };
                                        })
                                    };
                                }
                                return buttonData;
                            })
                        };
                    }
                    return btn;
                })
            }
        }));
    }

    const getNewPayloadObjectWithUpdatedPayloadKeyIdForCarousel = (field: any) => {
        const existedPayloads = Array.isArray(field.whatsapp_template_button_sub_type_field_value) ?
            field.whatsapp_template_button_sub_type_field_value?.map((subType: any, ind: number) => {
                return {
                    ...subType,
                    payload_key_id: ind,
                }
            })
            : [];

        return [...existedPayloads,
        {
            payload_key_id: field.whatsapp_template_button_field_data_id ? field.whatsapp_template_button_field_data_id
                : field.whatsapp_template_button_sub_type_field_value.length || 0, payload_key: "", payload_key_value: ""
        }
        ]
    }

    const handleAddPayloadDataCarousel = (btnTypeId: number, finalIndex: number, index: number, cardIndex: number, whatsappTemplateButtonIndex: number) => {
        setCreateTemplatePayload((prevState: any) => ({
            ...prevState,
            whatsapp_template_data: {
                ...prevState.whatsapp_template_data,
                whatsapp_template_carousel: {
                    ...prevState.whatsapp_template_data.whatsapp_template_carousel,
                    whatsapp_template_carousel_card: prevState.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card.map((card: any, ind: number) => {
                        // if (ind == cardIndex) {
                        return {
                            ...card,
                            whatsapp_template_button: card.whatsapp_template_button.map((btn: any, btnIndex: any) => {
                                if (btn.whatsapp_template_button_type_id === btnTypeId && btnIndex == whatsappTemplateButtonIndex) {
                                    return {
                                        ...btn,
                                        whatsapp_template_button_data: btn?.whatsapp_template_button_data?.map((buttonData: any, buttonDataIndex: any) => {
                                            if (buttonDataIndex === finalIndex) {
                                                return {
                                                    ...buttonData,
                                                    whatsapp_template_button_sub_type_field_data: buttonData.whatsapp_template_button_sub_type_field_data.map((field: any, fieldIndex: any) => {
                                                        if (field.whatsapp_template_button_sub_type_field_id === index) {
                                                            return {
                                                                ...field,
                                                                // whatsapp_template_button_sub_type_field_value: [
                                                                //     ...(Array.isArray(field.whatsapp_template_button_sub_type_field_value) ? 
                                                                //         field.whatsapp_template_button_sub_type_field_value : []), 

                                                                //     { payload_key_id: field.whatsapp_template_button_field_data_id ? field.whatsapp_template_button_field_data_id 
                                                                //         : field.whatsapp_template_button_sub_type_field_value.length || 0, payload_key: "", payload_key_value: "" }]
                                                                whatsapp_template_button_sub_type_field_value: getNewPayloadObjectWithUpdatedPayloadKeyIdForCarousel(field),
                                                            };
                                                        }
                                                        // return { ...field, whatsapp_template_button_field_data_variable: [] };
                                                        return { ...field };
                                                    })
                                                };
                                            }
                                            return buttonData;
                                        })
                                    };
                                }
                                return btn;
                            })
                        }
                        // }
                        // return card;
                    })
                }
            }
        }));
    }

    const getFlowListApi = async () => {
        const res = await agent.getWAFlowList.get(searchParams.get('id') ?? "");
        if (res.status && res.data) {
            const published_flows = res.data?.filter((flow: any) => flow?.whatsapp_flow_version_data?.find((version: any) => version?.whatsapp_flow_metadata_response?.whatsapp_flow_meta_status?.toLowerCase() == "published"));
            setPublishedFlowList(published_flows || []);
        } else {
            handleError(res);
        }
    }

    const getOptionsDataForAutoCompleteField = (btnTypeId: number, subTypeId: number, genericData: any) => {
        if (genericData?.field_name?.toLowerCase() == "flow") {
            return publishedFlowList || [];
        } else {
            const btn = whatsappTemplateButtonGenericData?.find((btn) => btn?.whatsapp_template_button_type_id == btnTypeId);
            if(btn){
                const subTypeData = btn?.whatsapp_template_button_sub_type_data?.find((subType) => subType?.whatsapp_template_button_sub_type_id == subTypeId);
                if(subTypeData){
                    const fieldData = subTypeData?.whatsapp_template_button_sub_type_field_data?.find((fieldData) => fieldData?.field_name == genericData?.field_name);
                    if(fieldData){
                        return fieldData?.field_option_data || [];
                    }
                }
            }
            return [];
        }
    }

    const getUpdatedFieldCharacterLimit = (genericData: any) => {
        if (createTemplatePayload?.whatsapp_template_flag_interactive_message && (genericData?.field_name?.toLowerCase() == "button text" || genericData?.field_name?.toLowerCase() == "button description")) {
            if (genericData?.field_name?.toLowerCase() == "button text") {
                return getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList)?.button_text_character_limit;
            } else {
                return getValidationsFromInteractiveType(createTemplatePayload?.interactive_type_id, interactiveTypeList)?.btn_description_character_limit;
            }
        } else {
            return genericData?.field_character_limit;
        }
    }

    const getUpdatedFieldNameAndPlaceholderForListType = (genericData: any) => {
        if (createTemplatePayload?.whatsapp_template_flag_interactive_message && isInteractiveTypeMessageList(createTemplatePayload?.interactive_type_id, interactiveTypeList)) {
            return {
                field_name: genericData?.field_name?.replace(/Button/g, "Row")?.replace(/Text/g, "Title"),
                placeholder: genericData?.field_placeholder?.replace(/Button/g, "Row"),
            }
        }
        return {
            field_name: genericData?.field_name,
            placeholder: genericData?.field_placeholder,
        }
    }

    const checkDisableInputComponent = (genericData: any) => {
        const editableButtonFields = [
            TEMPLATE_BUTTON_FIELDS["BUTTON_TEXT"]?.toLowerCase(),
            TEMPLATE_BUTTON_FIELDS["BUTTON_DESCRIPTION"]?.toLowerCase()
        ]
        if(isAuthenticationTemplate) {
            return true;
        }
        if(editableButtonFields?.includes(genericData?.field_name?.toLowerCase()) && isBasicTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) && canUpdateTemplate(templateStatusDetails?.whatsapp_template_metadata?.meta_whatsapp_template_status_name, createTemplatePayload, whatsappTemplateTypes, draftId)){
            return genericData.field_static_value_flag;
        } else if(createTemplatePayload.whatsapp_template_id){
            return true;
        } else {
            return genericData.field_static_value_flag;
        }
    }

    const getInput = (whatsappTemplateButtonIndex: number, inputTypeName: string, genericData: any, btnTypeId: number, whatsappTemplateButtonDataIndex: number, subFieldIndex: number, subTypeId: number, whatsapp_template_button_sub_type_field_data: any, flagCarousel?: boolean, cardIndex?: number) => {
        switch (inputTypeName) {
            case "Autocomplete":
                return (
                    <Grid item xs={12}>
                        <Grid container direction={"column"} gap="15px">
                            <Grid item>
                                <Grid container gap={"5px"} alignItems={"center"}>
                                    <InputLabel className={`${globalStyles.formLabelFontSize} ${globalStyles.formLabelFontWeight}`}>
                                        {genericData.field_name}
                                        {!genericData.field_static_value_flag ?
                                            <Required />
                                            :
                                            <Tooltip title={"This is default text. It cannot be edited."} placement='top'>
                                                <InfoIcon sx={{ fontSize: "17px", marginLeft: "7px", cursor: "pointer" }} />
                                            </Tooltip>
                                        }
                                    </InputLabel>
                                    {(isFlowButton(btnTypeId) && autoCompleteValue(genericData, btnTypeId, subTypeId)) &&
                                        <GlobalTooltip
                                            placement='bottom'
                                            title="View Flow in detail"
                                        >
                                            <VisibilityIcon
                                                className={globalStyles.clickable}
                                                sx={{ height: "22px", width: "22px" }}
                                                onClick={() => {
                                                    window.open(`/channels/viewintegration/whatsapp/flowDetails?id=${searchParams.get('id') || ""}&flow_id=${autoCompleteValue(genericData, btnTypeId, subTypeId)?.whatsapp_flow_id}`, "_blank");
                                                }}
                                            />
                                        </GlobalTooltip>
                                    }
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Autocomplete
                                    disabled={checkDisableInputComponent(genericData)}
                                    fullWidth
                                    size='small'
                                    disablePortal
                                    className={styles.callToActionAutocomplete}
                                    sx={{
                                        '& .MuiInputBase-sizeSmall': {
                                            paddingBlock: "9px !important",
                                            borderRadius: "10px",
                                            fontSize: "15px !important"
                                        }
                                    }}
                                    getOptionLabel={(option: any) => option.field_option_value || option?.whatsapp_flow_name}
                                    options={getOptionsDataForAutoCompleteField(btnTypeId, subTypeId, genericData)}
                                    value={autoCompleteValue(genericData, btnTypeId, subTypeId)}
                                    renderInput={(params) => <TextField {...params} placeholder={genericData.field_placeholder} />}
                                    ListboxProps={{
                                        style: {
                                            maxHeight: 300,
                                        }
                                    }}
                                    onChange={(event, value) => {
                                        if (flagCarousel) {
                                            setCarouselPayloadOnChangeOfGetInput(whatsappTemplateButtonIndex, inputTypeName, "", value, btnTypeId, whatsappTemplateButtonDataIndex, genericData.whatsapp_template_button_sub_type_field_id, cardIndex || 0);
                                        }
                                        else {
                                            setPayloadOnChangeOfGetInput(whatsappTemplateButtonIndex, inputTypeName, "", value, btnTypeId, whatsappTemplateButtonDataIndex, genericData.whatsapp_template_button_sub_type_field_id);
                                        }

                                        const websiteUrl = whatsapp_template_button_sub_type_field_data?.find((subType: any) => {
                                            return subType?.field_name?.toLowerCase() == "website url";
                                        });
                                        if (websiteUrl) {
                                            const website_url = websiteUrl?.whatsapp_template_button_sub_type_field_value;

                                            if (flagCarousel) {
                                                handleVisitWebsiteVariable(website_url, "Website URL", whatsappTemplateButtonIndex, value.field_option_value.toLowerCase() === "dynamic", true, cardIndex);
                                            } else {
                                                handleVisitWebsiteVariable(website_url, "Website URL", whatsappTemplateButtonIndex, value.field_option_value.toLowerCase() === "dynamic");
                                            }
                                        }
                                        if (genericData.field_name.toLowerCase() === "url type" && value) {
                                            if (value.field_option_value.toLowerCase() === "dynamic") {
                                                handleSampleTextChange(whatsappTemplateButtonIndex, whatsappTemplateButtonDataIndex, "", false);
                                            } else if (value.field_option_value.toLowerCase() === "static") {
                                                if (flagCarousel) {
                                                    let carouselData = carouselInvalidId?.find((ids: any) => ids.index == cardIndex)
                                                    if (carouselData) {
                                                        if (carouselData?.inValidIds?.includes(String(whatsappTemplateButtonIndex))) {
                                                            setCarouselInvalidId((prevCarousel: any) =>
                                                                prevCarousel?.map((carousel: any) => {
                                                                    if (carousel.index == cardIndex) {
                                                                        return {
                                                                            ...carousel,
                                                                            inValidIds: carousel.inValidIds.filter((ele: any) => ele != String(whatsappTemplateButtonIndex))
                                                                        }
                                                                    }
                                                                    return carousel
                                                                })
                                                            )
                                                            inValidIdRefCarousel.current = inValidIdRefCarousel.current.map((refC) => {
                                                                if (refC.index == cardIndex) {
                                                                    return {
                                                                        ...refC,
                                                                        inValids: refC.inValids.filter((ele: any) => ele != String(whatsappTemplateButtonIndex))
                                                                    }
                                                                }
                                                                return refC
                                                            })
                                                        }
                                                    }
                                                }
                                                else {
                                                    if (inValidId.includes(String(whatsappTemplateButtonIndex))) {
                                                        setInvalidId(inValidId.filter((ele: any) => ele != String(whatsappTemplateButtonIndex)));
                                                        inValidIdRef.current = inValidIdRef.current.filter((ele) => ele != String(whatsappTemplateButtonIndex));
                                                    }
                                                }
                                            }
                                        }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>);
            case "Textfield":
                return <Grid item xs={12}>
                    <Grid container direction={"column"} gap="15px">
                        <Grid item>
                            <InputLabel className={`${globalStyles.formLabelFontSize} ${globalStyles.formLabelFontWeight}`}>
                                {getUpdatedFieldNameAndPlaceholderForListType(genericData)?.field_name}
                                {genericData.field_name.toLowerCase() != "button description" &&
                                    <>
                                        {!genericData.field_static_value_flag ?
                                            <Required />
                                            :
                                            <Tooltip title={"This is default text. It cannot be edited."} placement='top'>
                                                <InfoIcon sx={{ fontSize: "17px", marginLeft: "7px", cursor: "pointer" }} />
                                            </Tooltip>
                                        }
                                    </>
                                }
                            </InputLabel>
                        </Grid>
                        <Grid item>
                            <TextField
                                disabled={checkDisableInputComponent(genericData)}
                                id="outlined-basic"
                                variant="outlined"
                                fullWidth
                                className={styles.templateGlobalTextfield}

                                placeholder={getUpdatedFieldNameAndPlaceholderForListType(genericData)?.placeholder}
                                // helperText={genericData.whatsapp_template_button_sub_type_field_value ? `${genericData.whatsapp_template_button_sub_type_field_value.length}/${genericData.field_character_limit}` : ""}
                                size='medium'
                                sx={{
                                    border: genericData.field_name === "Website URL" && inValidId.includes(whatsappTemplateButtonIndex) && !flagCarousel ? "1px solid red" : genericData.field_name === "Website URL" && carouselInvalidId?.find((carousels: any) => carousels.index == cardIndex)?.inValidIds?.includes(whatsappTemplateButtonIndex) && flagCarousel ? "1px solid red" : ""
                                }}
                                FormHelperTextProps={{
                                    style: {
                                        textAlign: 'right',
                                        fontSize: '12px',
                                        fontWeight: '600'
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <span style={{ fontSize: '12px', fontWeight: '600', paddingLeft: "5px" }}>
                                            {genericData.whatsapp_template_button_sub_type_field_value ? `${genericData.whatsapp_template_button_sub_type_field_value.length}/${getUpdatedFieldCharacterLimit(genericData)}` : ""}
                                        </span>
                                    ),
                                }}
                                onChange={(event) => {
                                    if (event.target.value.length <= getUpdatedFieldCharacterLimit(genericData)) {
                                        if (flagCarousel) {
                                            setCarouselPayloadOnChangeOfGetInput(whatsappTemplateButtonIndex, inputTypeName, genericData.field_name, event.target.value, btnTypeId, whatsappTemplateButtonDataIndex, genericData.whatsapp_template_button_sub_type_field_id, cardIndex || 0)
                                        }
                                        else {
                                            setPayloadOnChangeOfGetInput(whatsappTemplateButtonIndex, inputTypeName, genericData.field_name, event.target.value, btnTypeId, whatsappTemplateButtonDataIndex, genericData.whatsapp_template_button_sub_type_field_id);
                                        }
                                    }
                                    if (genericData.field_name.toLowerCase() === "website url") {
                                        if (event.target.value.length === 0) {
                                            if (flagCarousel) {
                                                let carouselData = carouselInvalidId?.find((ids: any) => ids.index == cardIndex)
                                                if (carouselData) {
                                                    if (carouselData?.inValidIds?.includes(String(whatsappTemplateButtonIndex))) {
                                                        setCarouselInvalidId((prevCarousel: any) =>
                                                            prevCarousel?.map((carousel: any) => {
                                                                if (carousel.index == cardIndex) {
                                                                    return {
                                                                        ...carousel,
                                                                        inValidIds: carousel.inValidIds.filter((ele: any) => ele != String(whatsappTemplateButtonIndex))
                                                                    }
                                                                }
                                                                return carousel
                                                            })
                                                        )
                                                        inValidIdRefCarousel.current = inValidIdRefCarousel.current.map((refC) => {
                                                            if (refC.index == cardIndex) {
                                                                return {
                                                                    ...refC,
                                                                    inValids: refC.inValids.filter((ele: any) => ele != String(whatsappTemplateButtonIndex))
                                                                }
                                                            }
                                                            return refC
                                                        })
                                                    }
                                                }
                                            }
                                            else {
                                                if (inValidId.includes(String(whatsappTemplateButtonIndex))) {
                                                    setInvalidId(inValidId.filter((ele: any) => ele != String(whatsappTemplateButtonIndex)));
                                                    inValidIdRef.current = inValidIdRef.current.filter((ele) => ele != String(whatsappTemplateButtonIndex));
                                                }
                                            }
                                            // handleSampleTextChange(whatsappTemplateButtonIndex, whatsappTemplateButtonDataIndex, "", true);
                                        }
                                        let url_type = "";
                                        const urlType = whatsapp_template_button_sub_type_field_data?.find((subType: any) => {
                                            return subType?.field_name?.toLowerCase() == "url type";
                                        });
                                        if (urlType) {
                                            const selectedUrlType = urlType?.field_option_data?.find((option: any) => option.field_option_id == urlType?.whatsapp_template_button_sub_type_field_option_id);
                                            if (selectedUrlType) {
                                                url_type = selectedUrlType?.field_option_value;
                                            }
                                        }
                                        if (flagCarousel) {
                                            handleOnBlurOfDynamicVarOfBtn(event.target.value, genericData.field_name, whatsappTemplateButtonIndex, whatsappTemplateButtonDataIndex, true, true, cardIndex);
                                            if (url_type) {
                                                handleVisitWebsiteVariable(event.target.value, genericData.field_name, whatsappTemplateButtonIndex, url_type?.toLowerCase() == "dynamic", true, cardIndex);
                                            }
                                        }
                                        else {
                                            handleOnBlurOfDynamicVarOfBtn(event.target.value, genericData.field_name, whatsappTemplateButtonIndex, whatsappTemplateButtonDataIndex, true);
                                            if (url_type) {
                                                handleVisitWebsiteVariable(event.target.value, genericData.field_name, whatsappTemplateButtonIndex, url_type?.toLowerCase() == "dynamic");
                                            }
                                        }
                                    }
                                }}
                                // onBlur={() => handleValidWebsite(genericData.whatsapp_template_button_sub_type_field_value, genericData.field_name, whatsappTemplateButtonDataIndex)}
                                value={genericData.field_static_value_flag ? genericData.field_static_value : genericData.whatsapp_template_button_sub_type_field_value ?? null}
                                autoComplete='off'
                            // helperText={genericData.field_name === "Website URL" && inValidId.includes(whatsappTemplateButtonDataIndex) &&<span>Please Enter Valid URL</span>}
                            />
                            {genericData.field_name === "Website URL" && inValidId?.includes(whatsappTemplateButtonIndex) && !flagCarousel && <span style={{ fontSize: "13px", color: "red" }}>Please Enter Valid URL</span>}
                            {genericData.field_name === "Website URL" && (carouselInvalidId?.find((carousels: any) => carousels.index == cardIndex)?.inValidIds && carouselInvalidId?.find((carousels: any) => carousels.index == cardIndex)?.inValidIds?.includes(whatsappTemplateButtonIndex)) && flagCarousel && <span style={{ fontSize: "13px", color: "red" }}>Please Enter Valid URL</span>}
                        </Grid>
                    </Grid>
                </Grid>
            case "Object":
                return <Grid item xs={12}>
                    <Grid container direction={"column"} gap="15px">
                        <Grid item>
                            <InputLabel className={`${globalStyles.formLabelFontSize} ${globalStyles.formLabelFontWeight}`}>
                                {genericData.field_name}
                                {!genericData.field_static_value_flag ?
                                    // <Required />
                                    <></>
                                    :
                                    <Tooltip title={"This is default text. It cannot be edited."} placement='top'>
                                        <InfoIcon sx={{ fontSize: "17px", marginLeft: "7px", cursor: "pointer" }} />
                                    </Tooltip>
                                }
                            </InputLabel>
                        </Grid>
                        <Grid item>
                            <GlobalButton
                                buttonText={`Add ${genericData.field_name}`}
                                className='primaryButtonStyle'
                                sx={{ padding: "6px 20px", minWidth: "150px" }}
                                onClick={() => {
                                    if (flagCarousel) {
                                        handleAddPayloadDataCarousel(btnTypeId, whatsappTemplateButtonDataIndex, genericData.whatsapp_template_button_sub_type_field_id, cardIndex || 0, whatsappTemplateButtonIndex)
                                    }
                                    else {
                                        handleAddPayloadData(btnTypeId, whatsappTemplateButtonDataIndex, genericData.whatsapp_template_button_sub_type_field_id, whatsappTemplateButtonIndex)
                                    }
                                }}
                                disabled={createTemplatePayload.whatsapp_template_id ? true : false}
                            />
                        </Grid>
                    </Grid>
                </Grid>
        }
    }


    function checkFlagError(type: string) {
        let wordForBody = createTemplatePayload.whatsapp_template_data.whatsapp_template_body.whatsapp_template_body_value;
        let wordForHeader = createTemplatePayload.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_value || "";
        if (type.toLowerCase() === "body") {
            return checkErrorFromWord(wordForBody, createTemplatePayload.flag_named_parameter);
        } else if (type.toLowerCase() === "header") {
            return checkErrorFromWord(wordForHeader, createTemplatePayload.flag_named_parameter);
        } else if (type.toLowerCase() === "both") {
            if (wordForHeader) return checkErrorFromWord(wordForBody, createTemplatePayload.flag_named_parameter) || checkErrorFromWord(wordForHeader, createTemplatePayload.flag_named_parameter);
            return checkErrorFromWord(wordForBody, createTemplatePayload.flag_named_parameter);
        }
    }

    function checkFlagErrorCarousel(type: string, bodyIndex?: number) {
        let wordForBody = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card[bodyIndex || 0]?.whatsapp_template_body?.whatsapp_template_body_value;
        let wordForHeader = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_header || "";
        if (type.toLowerCase() === "body") {
            return checkErrorFromWord(wordForBody, createTemplatePayload.flag_named_parameter);
        }
        else if (type.toLowerCase() === "header") {
            return checkErrorFromWord(wordForHeader, createTemplatePayload.flag_named_parameter);
        }
        else if (type.toLowerCase() === "both") {
            if (wordForHeader) return checkErrorFromWord(wordForBody, createTemplatePayload.flag_named_parameter) || checkErrorFromWord(wordForHeader, createTemplatePayload.flag_named_parameter);
            return checkErrorFromWord(wordForBody, createTemplatePayload.flag_named_parameter);
        }
    }

    function checkHeaderCard() {
        if (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_header?.trim()?.length > 0) {
            if (createTemplatePayload.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_header_dynamic_variable.filter((variable) => variable.whatsapp_template_dynamic_variable_sample_value.trim() == "")?.length === 0) {
                return true
            }
            return false
        }
        return false
    }

    function checkBodyValueVariableCard() {
        let finalValue = false;
        for (let i = 0; i < createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.length; i++) {
            let wordForBody = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card[i]?.whatsapp_template_body?.whatsapp_template_body_value;
            if (checkErrorFromWord(wordForBody, createTemplatePayload.flag_named_parameter) == true) {
                finalValue = true
            }
        }
        return finalValue
    }

    function checkButtonVariableCard() {
        for (let i = 0; i < createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.length; i++) {
            for (const button of createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card[i]?.whatsapp_template_button) {
                for (const buttonData of button?.whatsapp_template_button_data) {
                    if (buttonData?.whatsapp_template_button_sub_type_field_data) {
                        for (const fieldData of buttonData?.whatsapp_template_button_sub_type_field_data) {
                            if (fieldData.field_static_value_flag === true) {
                                return false;
                            }
                            if (fieldData.field_name.toLowerCase() === "website url" && fieldData.whatsapp_template_button_field_data_variable && fieldData.whatsapp_template_button_field_data_variable.length > 0) {
                                if (fieldData.whatsapp_template_button_field_data_variable?.[0]?.whatsapp_template_dynamic_variable_sample_value.trim().length === 0) {
                                    return true;
                                }
                            }
                            if (fieldData.field_type.toLowerCase() == "textfield" && (!fieldData.whatsapp_template_button_sub_type_field_value || (typeof fieldData.whatsapp_template_button_sub_type_field_value == "string" && fieldData.whatsapp_template_button_sub_type_field_value.trim() === ''))
                            ) {
                                if (fieldData.field_name.toLowerCase() != "button description") {
                                    return true;
                                }
                            }
                            if (fieldData.field_name.toLowerCase() == "payload" && (typeof fieldData.whatsapp_template_button_sub_type_field_value == "object" && fieldData.whatsapp_template_button_sub_type_field_value?.filter((values: any) => values.payload_key.trim() == "" || values.payload_key_value.trim() == "")?.length > 0)
                            ) {
                                return true;
                            }
                            if (fieldData.field_type.toLowerCase() == "autocomplete" && (fieldData.whatsapp_template_button_sub_type_field_option_id == null || Number(fieldData.whatsapp_template_button_sub_type_field_option_id) === 0)
                            ) {
                                return true;
                            }
                        }
                    }
                }
            }
        }
    }

    function checkBodyVariableCard() {
        return createTemplatePayload.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.every(
            (bCard) =>
                bCard.whatsapp_template_body?.whatsapp_template_body_variable_data?.every(
                    (variable) =>
                        typeof variable.whatsapp_template_dynamic_variable_sample_value === "string" &&
                        variable.whatsapp_template_dynamic_variable_sample_value.trim() !== ""
                )
        );
    }

    function checkBodyDescriptionCards() {
        return createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.every((cards) => cards.whatsapp_template_body?.whatsapp_template_body_description?.trim()?.length > 0)
    }

    function checkBodyValueCards() {
        return createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.every((cards) => cards.whatsapp_template_body?.whatsapp_template_body_value?.trim()?.length > 0)
    }

    function checkButtonLengthCard() {
        return createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.every((cards) => cards?.whatsapp_template_button?.length >= 1)
    }


    const checkCountOfButtons = (btnId: number, subTypeID: number, maximumCount: number, flagCarousel?: boolean): boolean => {
        // let btnIndex = createTemplatePayload.whatsapp_template_data.whatsapp_template_button.findIndex((btn) => Number(btn.whatsapp_template_button_type_id) == btnId)
        // if (btnIndex !== -1) {
        //     if (createTemplatePayload.whatsapp_template_data.whatsapp_template_button[btnIndex].whatsapp_template_button_data.filter((btn: any) => btn.whatsapp_template_button_sub_type_id == subTypeID).length == maximumCount) {
        //         return true;
        //     }
        //     else {
        //         return false;
        //     }
        // } else {
        //     return false;
        // }
        if (flagCarousel) {
            if (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card?.[0]?.whatsapp_template_button.flatMap((btn: any) => btn?.whatsapp_template_button_data).filter((btn: any) => btn?.whatsapp_template_button_sub_type_id == subTypeID).length == maximumCount) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            if (createTemplatePayload.whatsapp_template_data.whatsapp_template_button.flatMap((btn: any) => btn?.whatsapp_template_button_data).filter((btn: any) => btn?.whatsapp_template_button_sub_type_id == subTypeID).length == maximumCount) {
                return true;
            }
            else {
                return false;
            }
        }
    }

    const getMenuDisableFlag = (btnId: number, subType: any, flagCarousel?: boolean) => {
        let subTypeID = subType.whatsapp_template_button_sub_type_id
        const btnSubTypeName = subType?.whatsapp_template_button_sub_type_name?.toLowerCase();
        if (subType.whatsapp_template_button_sub_type_flag_active) {
            // if (createTemplatePayload.whatsapp_template_data.whatsapp_template_button.length > 0) {
            switch (btnSubTypeName) {
                // case 1: // Marketing opt-out
                case BTN_SUB_TYPE_NAMES['MARKETING_OPT_OUT']?.toLowerCase():
                    {
                        // Category: Marketing
                        if (createTemplatePayload.whatsapp_template_data.whatsapp_template_category_id === getTemplateCategoryId(TEMPLATE_CATEGORY?.MARKETING, templateCategoryList ?? [])) {
                            return checkCountOfButtons(btnId, subTypeID, maximumAllowedButtons(btnSubTypeName, createTemplatePayload, interactiveTypeList), flagCarousel);
                        }
                        else {
                            return true
                        };
                    }
                // case 2: // Custom 
                case BTN_SUB_TYPE_NAMES['CUSTOM']?.toLowerCase():
                    if (createTemplatePayload.whatsapp_template_flag_interactive_message) {
                        if (isInteractiveTypeMessageFlow(createTemplatePayload?.interactive_type_id, interactiveTypeList) || isInteractiveTypeMessageCtaUrl(createTemplatePayload?.interactive_type_id, interactiveTypeList)) {
                            return true;
                        }
                        if (createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.find((btn) => btn?.whatsapp_template_button_data?.[0]?.whatsapp_template_button_sub_type_id == getButtonTypeIdByName(whatsappTemplateButtonGenericData, BTN_SUB_TYPE_NAMES['VISIT_WEBSITE']))) { // Interactive message, only supports either custom button or visit website.
                            return true;
                        }
                    }
                    return false;
                // case 3: //view website
                // if(createTemplatePayload.whatsapp_template_flag_interactive_message){
                // if(createTemplatePayload?.whatsapp_template_data?.whatsapp_template_button?.find((btn) => btn.whatsapp_template_button_data?.[0]?.whatsapp_template_button_sub_type_id == 2)){
                //     return true;
                // }
                // return checkCountOfButtons(btnId, subTypeID, maximumAllowedButtons(subTypeID, createTemplatePayload, interactiveTypeList), flagCarousel); 
                //     return true;
                // } else {
                // return checkCountOfButtons(btnId, subTypeID, maximumAllowedButtons(subTypeID, createTemplatePayload, interactiveTypeList), flagCarousel); 
                // }
                default:
                    return checkCountOfButtons(btnId, subTypeID, maximumAllowedButtons(btnSubTypeName, createTemplatePayload, interactiveTypeList), flagCarousel); // Interactive Message, only supports custom button.  
            }
            // } 
            // else {
            //     return false
            // }
        } else {
            return true;
        }
    }

    const previousPayloadRef = useRef<createWhatsappTemplatePayload | null>(null);

    const handleCategoryChange = (categoryId: number) => {
        const id = Number(categoryId);

        if (!previousPayloadRef.current) {
            previousPayloadRef.current = createTemplatePayload;
        }

        const getBasePayload = () => (previousPayloadRef.current ?? createTemplatePayload);

        const buildPayloadWithId = (base: createWhatsappTemplatePayload, categoryId: number) => ({
            ...base,
            whatsapp_template_data: {
                ...base.whatsapp_template_data,
                whatsapp_template_category_id: categoryId,
            },
        });

        switch (id) {
            case getTemplateCategoryId(TEMPLATE_CATEGORY?.AUTHENTICATION, templateLibraryCategoryList ?? []):
                setCreateTemplatePayload(createAuthenticationTemplateFromScratch(false, templateLibraryCategoryList ?? [], whatsappTemplateButtonGenericData ?? []) as createWhatsappTemplatePayload);
                break;

            case getTemplateCategoryId(TEMPLATE_CATEGORY?.MARKETING, templateLibraryCategoryList ?? []):
            case getTemplateCategoryId(TEMPLATE_CATEGORY?.UTILITY, templateLibraryCategoryList ?? []): {
                setCreateTemplatePayload(buildPayloadWithId(getBasePayload(), id));
                break;
            }

            default: {
                setCreateTemplatePayload(getBasePayload());
                previousPayloadRef.current = null;
                break;
            }
        }
    };

    const flagCategoryEditable = (createTemplatePayload: createWhatsappTemplatePayload, category_id: number) => {
        if (createTemplatePayload?.whatsapp_template_flag_interactive_message) {
            return false
        } else {
            // if (category_id === 3) {
            //     return false
            // } else {
                if (isCarouselTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) || isCatalogTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)) {
                    return false
                }
                else if (createTemplatePayload?.whatsapp_template_id) {
                    return false
                } else {
                    return true
                }
            // }
        }

    }



    const uploadFileHandler = async (e: any) => {
        for (var i = 0; i < e.target.files.length; i++) {
            const file: any = e.target.files[i];

            file.isUploading = true;
            setFiles([file]);

            let formData = new FormData()
            formData.append(
                "file", file, file.name,
            )
            formData.append("chatbot_flag", "true");

            let config = {
                onUploadProgress: (progressEvent: any) => {
                    const { loaded, total } = progressEvent;
                    var percent = Math.floor((loaded * 100) / total)
                    setProgress({ ...progress, percent: percent, filename: file.name })
                }
            }

            setFlagLoading({ ...flagLoading, flagRoundLoader: true })
            await agent.uploadFile.post(formData, config).then(async (res) => {
                if (res.status) {
                    file.isUploading = false;
                    file.file_data = res.data.data;

                    file.google_storage_id = res.data.data.google_storage_id;
                    await setFiles((old: any) => {
                        let temp = [...old]
                        let fileType = file.name.split('.').pop()
                        let fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? ""
                        temp.map((rr: any) => {
                            if (rr.google_storage_id == file.google_storage_id) {
                                rr.isUploading = false;
                                rr.file_data = res.data.data;
                                rr.google_storage_id = res.data.data.google_storage_id;
                                // rr.page_field_id = id;
                                rr.previewImageSrc = fileTypeIconSrc;
                            }
                        })
                        return temp
                    })
                    setIsFileUploaded(false);
                    setCreateTemplatePayload((prevState) => ({
                        ...prevState,
                        whatsapp_template_data: {
                            ...prevState.whatsapp_template_data,
                            whatsapp_template_header: {
                                ...prevState.whatsapp_template_data.whatsapp_template_header,
                                whatsapp_template_header_data: prevState.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data.map((headerData) => {
                                    return {
                                        ...headerData,
                                        whatsapp_template_header_data_value: res.data.data.file_path,
                                        whatsapp_template_header_data_google_storage_id: res.data.data.google_storage_id,
                                    }
                                })
                            },
                        },
                    }));

                    let images = [];

                    for (let i = 0; i < e.target.files.length; i++) {
                        images.push(URL.createObjectURL(e.target.files[i]))
                    }
                }
            }).catch((err) => {
                showError("Something went wrong!")
                setFiles([])
                // inform the user
                console.error(err)
                // removeFile(file.name)
            });

            setFlagLoading({ ...flagLoading, flagRoundLoader: false })
        }

    }

    const uploadFileHandlerCarousel = async (e: any, cardIndex: number) => {
        for (var i = 0; i < e.target.files.length; i++) {
            const file: any = e.target.files[i];

            file.isUploading = true;
            setCarouselFiles((prev: any[]) => {
                const exists = prev.some((carouselFile) => carouselFile.index === cardIndex);
                if (exists) {
                    return prev.map((carouselFile) => {
                        if (carouselFile.index === cardIndex) {
                            return {
                                ...carouselFile,
                                carousels: [file]
                            };
                        }
                        return carouselFile;
                    });
                } else {
                    return [
                        ...prev,
                        {
                            index: cardIndex,
                            carousels: [file]
                        }
                    ];
                }
            });

            let formData = new FormData()
            formData.append(
                "file", file, file.name,
            )
            formData.append("chatbot_flag", "true");

            let config = {
                onUploadProgress: (progressEvent: any) => {
                    const { loaded, total } = progressEvent;
                    var percent = Math.floor((loaded * 100) / total)
                    setProgress({ ...progress, percent: percent, filename: file.name })
                }
            }

            setFlagLoading({ ...flagLoading, flagRoundLoader: true })
            await agent.uploadFile.post(formData, config).then(async (res) => {
                if (res.status) {
                    file.isUploading = false;
                    file.file_data = res.data.data;

                    file.google_storage_id = res.data.data.google_storage_id;
                    await setCarouselFiles((prev: any[]) => {
                        const exists = prev.some((carouselFile) => carouselFile.index == cardIndex);

                        if (exists) {
                            return prev.map((carouselFile) => {
                                if (carouselFile.index == cardIndex) {
                                    const updatedFiles = [...carouselFile.carousels]
                                    const fileType = file.name.split('.').pop();
                                    let fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? ""
                                    updatedFiles.map((rr: any) => {
                                        if (rr.google_storage_id == file.google_storage_id) {
                                            rr.isUploading = false;
                                            rr.file_data = res.data.data;
                                            rr.google_storage_id = res.data.data.google_storage_id;
                                            // rr.page_field_id = id;
                                            rr.previewImageSrc = fileTypeIconSrc;
                                        }
                                    })
                                    return {
                                        index: cardIndex,
                                        carousels: updatedFiles
                                    }
                                }
                                return carouselFile;
                            });
                        } else {
                            const fileType = file.name.split('.').pop();
                            const fileTypeIconSrc = getFileTypeImgIcon(fileType) ?? "";

                            return [
                                ...prev,
                                {
                                    index: cardIndex,
                                    carousels: [{
                                        ...file,
                                        isUploading: false,
                                        file_data: res.data.data,
                                        google_storage_id: res.data.data.google_storage_id,
                                        previewImageSrc: fileTypeIconSrc
                                    }]
                                }
                            ];
                        }
                    });
                    setIsFileUploaded(false);
                    setCreateTemplatePayload((prevState) => ({
                        ...prevState,
                        whatsapp_template_data: {
                            ...prevState.whatsapp_template_data,
                            whatsapp_template_carousel: {
                                ...prevState.whatsapp_template_data?.whatsapp_template_carousel,
                                whatsapp_template_carousel_card: prevState.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card.map((card: any, ind: number) => {
                                    if (ind == cardIndex) {
                                        return {
                                            ...card,
                                            whatsapp_template_header: {
                                                ...card.whatsapp_template_header,
                                                whatsapp_template_header_data: card.whatsapp_template_header.whatsapp_template_header_data.map((headerData: any) => {
                                                    return {
                                                        ...headerData,
                                                        whatsapp_template_header_data_value: res.data.data.file_path,
                                                        whatsapp_template_header_data_google_storage_id: res.data.data.google_storage_id,
                                                    }
                                                })
                                            }
                                        }
                                    }
                                    return card;
                                })
                            }
                        },
                    }));

                    let images = [];

                    for (let i = 0; i < e.target.files.length; i++) {
                        images.push(URL.createObjectURL(e.target.files[i]))
                    }
                }
            }).catch((err) => {
                showError("Something went wrong!")
                setFiles([])
                // inform the user
                console.error(err)
                // removeFile(file.name)
            });

            setFlagLoading({ ...flagLoading, flagRoundLoader: false })
        }
    }

    const removeUploadedFile = async (storage_id: any, showSuccessMessage: boolean) => {
        await agent.removeUploadedFile.delete(storage_id).then(async (res) => {
            if (res.data.status) {
                // setFiles([]);
                if (showSuccessMessage) {
                    showSuccess("File Deleted Successfully")
                }
            } else {
                handleError(res.data);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const removeFileHandler = async (storage_id: number) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true })
        if (!(createTemplatePayload.whatsapp_template_id) && !searchParams.get('copy_template')) {
            removeUploadedFile(storage_id, true);
        }
        setFiles(() => {
            return files.filter((file: any) => {
                return file.file_data.google_storage_id != storage_id;
            });
        });
        setCreateTemplatePayload((prevState) => ({
            ...prevState,
            whatsapp_template_data: {
                ...prevState.whatsapp_template_data,
                whatsapp_template_header: {
                    ...prevState.whatsapp_template_data.whatsapp_template_header,
                    whatsapp_template_header_data: prevState.whatsapp_template_data.whatsapp_template_header.whatsapp_template_header_data.map((headerData) => {
                        return {
                            ...headerData,
                            whatsapp_template_header_data_value: "",
                            whatsapp_template_header_data_google_storage_id: 0,
                        }
                    })
                },
            },
        }));
        setFlagLoading({ ...flagLoading, flagRoundLoader: false })
    }

    const removeFileHandlerCarousel = async (storage_id: number, cardIndex: number) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true })
        if (!(createTemplatePayload.whatsapp_template_id) && !searchParams.get('copy_template')) {
            removeUploadedFile(storage_id, true);
        }
        setCarouselFiles((prevFiles: any) =>
            prevFiles.map((file: any) => {
                if (file.index === cardIndex) {
                    return {
                        ...file,
                        carousels: file.carousels.filter((img: any) => img.google_storage_id !== storage_id)
                    };
                }
                return file;
            })
        );
        setCreateTemplatePayload((prevState) => ({
            ...prevState,
            whatsapp_template_data: {
                ...prevState.whatsapp_template_data,
                whatsapp_template_carousel: {
                    ...prevState.whatsapp_template_data.whatsapp_template_carousel,
                    whatsapp_template_carousel_card: prevState.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card.map((card: any, ind: number) => {
                        if (ind == cardIndex) {
                            return {
                                ...card,
                                whatsapp_template_header: {
                                    ...card.whatsapp_template_header,
                                    whatsapp_template_header_data: card.whatsapp_template_header.whatsapp_template_header_data.map((headerData: any) => {
                                        return {
                                            ...headerData,
                                            whatsapp_template_header_data_value: "",
                                            whatsapp_template_header_data_google_storage_id: 0,
                                        }
                                    })
                                }
                            }
                        }
                        return card;
                    })
                }
            },
        }));
        setFlagLoading({ ...flagLoading, flagRoundLoader: false })
    }

    const checkForAddDynamicVar = (action: createWhatsappTemplateButton, field: createWhatsappTemplateButtonData): boolean => {
        const ctaBtnId = action.whatsapp_template_button_type_id;
        const subTypeId = field?.whatsapp_template_button_sub_type_id;

        const urlType = field?.whatsapp_template_button_sub_type_field_data?.find((subField: createWhatsappTemplateButtonSubFieldData) => {
            return (subField.field_name.toLowerCase() === "url type");
        });
        const websiteURL = field?.whatsapp_template_button_sub_type_field_data?.find((subField: createWhatsappTemplateButtonSubFieldData) => {
            return (subField.field_name.toLowerCase() === "website url");
        });
        if (urlType && websiteURL) {
            if (ctaBtnId == 2 && subTypeId == 3 && urlType.whatsapp_template_button_sub_type_field_option_id == 3 && (typeof websiteURL.whatsapp_template_button_sub_type_field_value === "string") && websiteURL.whatsapp_template_button_sub_type_field_value.trim().length > 0) {
                return true;
            } else {
                return false;
            }
        }
        return false;
    }

    const handleSampleTextChange = (index: number, fieldIndex: number, value: string, isURL: boolean) => {
        setCreateTemplatePayload((prev) => ({
            ...prev,
            whatsapp_template_data: {
                ...prev.whatsapp_template_data,
                whatsapp_template_button: prev.whatsapp_template_data.whatsapp_template_button
                    .map((btn, btnIndex) =>
                        btnIndex === index
                            ? {
                                ...btn,
                                whatsapp_template_button_data: btn?.whatsapp_template_button_data.map(
                                    (field, fieldIdx) =>
                                        fieldIdx === fieldIndex
                                            ? {
                                                ...field,
                                                whatsapp_template_button_sub_type_field_data:
                                                    field.whatsapp_template_button_sub_type_field_data.map(
                                                        (subType) =>
                                                            subType.field_name.toLowerCase() === "website url"
                                                                ? {
                                                                    ...subType,
                                                                    whatsapp_template_button_field_data_variable: [
                                                                        {
                                                                            whatsapp_template_dynamic_variable_key: "{{1}}",
                                                                            whatsapp_template_dynamic_variable_sample_value: value,
                                                                        },
                                                                    ],
                                                                }
                                                                : subType
                                                    ),
                                            }
                                            : field
                                ),
                            }
                            : btn
                    ),
            },
        }));

        if (isURL) handleOnBlurOfDynamicVarOfBtn(value, "Website URL", fieldIndex, index, false);
    }

    const handleSampleTextChangeCarousel = (index: number, fieldIndex: number, value: string, isURL: boolean, cardIndex: number) => {
        setCreateTemplatePayload((prev) => ({
            ...prev,
            whatsapp_template_data: {
                ...prev.whatsapp_template_data,
                whatsapp_template_carousel: {
                    ...prev.whatsapp_template_data?.whatsapp_template_carousel,
                    whatsapp_template_carousel_card: prev.whatsapp_template_data?.whatsapp_template_carousel?.whatsapp_template_carousel_card.map((card: any, ind: number) => {
                        if (ind == cardIndex) {
                            return {
                                ...card,
                                whatsapp_template_button: card.whatsapp_template_button.map((btn: any, btnIndex: any) =>
                                    btnIndex === index
                                        ? {
                                            ...btn,
                                            whatsapp_template_button_data: btn?.whatsapp_template_button_data?.map(
                                                (field: any, fieldIdx: any) =>
                                                    fieldIdx === fieldIndex
                                                        ? {
                                                            ...field,
                                                            whatsapp_template_button_sub_type_field_data:
                                                                field?.whatsapp_template_button_sub_type_field_data?.map(
                                                                    (subType: any) =>
                                                                        subType.field_name.toLowerCase() === "website url"
                                                                            ? {
                                                                                ...subType,
                                                                                whatsapp_template_button_field_data_variable: [
                                                                                    {
                                                                                        whatsapp_template_dynamic_variable_key: "{{1}}",
                                                                                        whatsapp_template_dynamic_variable_sample_value: value,
                                                                                    },
                                                                                ],
                                                                            }
                                                                            : subType
                                                                ),
                                                        }
                                                        : field
                                            ),
                                        }
                                        : btn
                                ),
                            }
                        }
                        return card;
                    })
                }
            },
        }));

        if (isURL) handleOnBlurOfDynamicVarOfBtn(value, "Website URL", fieldIndex, index, false, true, cardIndex);
    }

    const handleOnBlurOfDynamicVarOfBtn = useCallback(
        debounce((value, field, whatsappTemplateButtonIndex, whatsappTemplateButtonDataIndex, isURL, flagCarousel?, cardIndex?) => {
            if (flagCarousel) {
                if (!isURL) {
                    handleValidWebsite(value, field, String(whatsappTemplateButtonIndex), cardIndex);
                } else {
                    handleValidWebsite(value, field, whatsappTemplateButtonIndex, cardIndex);
                }
            }
            else {
                if (!isURL) {
                    handleValidWebsite(value, field, String(whatsappTemplateButtonIndex));
                } else {
                    handleValidWebsite(value, field, whatsappTemplateButtonIndex);
                }
            }
        }, 1200), []
    );

    const handleValidWebsiteWithVariables = (website_value: string, field: string, index: number, isDynamicUrl: boolean, cardIndex?: number) => {
        if (cardIndex || cardIndex == 0) {
            let cardData = inValidIdRefCarousel?.current?.find((ids: any) => ids.index == cardIndex)
            if (field === "Website URL" && website_value.trim().length > 0) {
                let temp = isValidWebsiteURLWithVariable(website_value);
                if (temp || !isDynamicUrl) {
                    if (cardData) {
                        if (cardData.inValids?.includes(index)) {
                            setCarouselInvalidId((prevCarousels: any) =>
                                prevCarousels?.map((carousel: any) => {
                                    if (carousel.index == cardData.index) {
                                        return {
                                            ...carousel,
                                            inValidIds: carousel.inValidIds.filter((ele: any) => ele !== index)
                                        }
                                    }
                                    return carousel
                                })
                            )
                            inValidIdRefCarousel.current = inValidIdRefCarousel.current.map((refC) => {
                                if (refC.index == cardData.index) {
                                    return {
                                        ...refC,
                                        inValids: refC.inValids.filter((ele: any) => ele !== index)
                                    }
                                }
                                return refC
                            })
                        }
                    }
                } else {
                    if (cardData) {
                        if (cardData.inValids?.includes(index)) { }
                        else {
                            setCarouselInvalidId((prevCarousels: any) =>
                                prevCarousels?.map((carousel: any) => {
                                    if (carousel.index == cardData.index) {
                                        return {
                                            ...carousel,
                                            inValidIds: carousel.inValidIds && carousel.inValidIds.includes(index) ? carousel.inValidIds : [...carousel.inValidIds, index]
                                        }
                                    }
                                    return carousel
                                })
                            )
                            inValidIdRefCarousel.current = inValidIdRefCarousel.current.map((refC) => {
                                if (refC.index == cardData.index) {
                                    return {
                                        ...refC,
                                        inValids: refC.inValids && refC.inValids.includes(index) ? refC.inValids : [...refC.inValids, index]
                                    }
                                }
                                return refC
                            })
                        }
                    }
                }
            } else if (field === "Website URL" && website_value.trim().length == 0) {
                if (cardData) {
                    if (cardData.inValids?.includes(index)) {
                        setCarouselInvalidId((prevCarousels: any) =>
                            prevCarousels.map((carousel: any) => {
                                if (carousel.index == cardData.index) {
                                    return {
                                        ...carousel,
                                        inValidIds: carousel.inValidIds.filter((ele: any) => ele !== index)
                                    }
                                }
                                return carousel
                            })
                        )
                        inValidIdRefCarousel.current = inValidIdRefCarousel.current.map((refC) => {
                            if (refC.index == cardData.index) {
                                return {
                                    ...refC,
                                    inValids: refC.inValids.filter((ele: any) => ele !== index)
                                }
                            }
                            return refC
                        })
                    }
                }
            }
        }
        else {
            if (field === "Website URL" && website_value.trim().length > 0) {
                let temp = isValidWebsiteURLWithVariable(website_value);
                if (temp || !isDynamicUrl) {
                    if (inValidIdRef.current.includes(index)) {
                        setInvalidId(inValidIdRef.current.filter((ele: any) => ele !== index))
                        inValidIdRef.current = inValidIdRef.current.filter((ele: any) => ele !== index);
                    } else {
                    }
                } else {
                    if (inValidIdRef.current.includes(index)) {
                    } else {
                        setInvalidId((prev: any) => [...prev, index])
                        inValidIdRef.current = [...inValidIdRef.current, index];
                    }
                }
            } else if (field === "Website URL" && website_value.trim().length == 0) {
                if (inValidIdRef.current.includes(index)) {
                    setInvalidId(inValidIdRef.current.filter((ele: any) => ele !== index))
                    inValidIdRef.current = inValidIdRef.current.filter((ele: any) => ele !== index);
                } else {
                }
            }
        }
    }

    const handleVisitWebsiteVariable = useCallback(
        debounce((value, field, whatsappTemplateButtonIndex, isDynamicUrl, flagCarousel?, cardIndex?) => {
            if (flagCarousel) {
                handleValidWebsiteWithVariables(value, field, whatsappTemplateButtonIndex, isDynamicUrl, cardIndex);
            } else {
                handleValidWebsiteWithVariables(value, field, whatsappTemplateButtonIndex, isDynamicUrl);
            }
        }, 1200), []
    );

    useEffect(() => {
        const updatedBreadcrumbs = [
            homeBreadcrumb,
            { ...channelsBreadcrumb },
            { name: getWabaName(integrationListNewStructure, Number(searchParams.get('id')), "Whatsapp"), path: `/channels/viewintegration/Whatsapp?id=${id}`, isActive: false, isSamePageRedirecting: pathname === "/channels/viewintegration/whatsapp" },
            { ...templateMessagesBreadcrumb, path: `/channels/viewintegration/whatsapp/templatemessages?id=${id}` },
            template_id ? { name: existingTemplateData.whatsapp_template_data.whatsapp_template_name, path: `/channels/viewintegration/whatsapp/legacy/templateinfo?id=${id}&template_id=${template_id}`, isActive: true } : { name: "Create Template", path: `/channels/viewintegration/whatsapp/legacy/templateinfo?id=${id}`, isActive: true }
        ];
        setBreadCrumbs(updatedBreadcrumbs);
    }, [integrationListNewStructure, existingTemplateData])

    const flagShowVariableTooltipForVisitWebsite = (subField: any, whatsapp_template_button_sub_type_field_data: any) => {
        if (subField?.field_name?.toLowerCase() == "website url") {
            const urlType = whatsapp_template_button_sub_type_field_data?.find((subType: any) => {
                return subType?.field_name?.toLowerCase() == "url type";
            });
            if (urlType) {
                const selectedUrlType = urlType?.field_option_data?.find((option: any) => option.field_option_id == urlType?.whatsapp_template_button_sub_type_field_option_id);
                if (selectedUrlType) {
                    if (selectedUrlType?.field_option_value?.toLowerCase() == "dynamic") {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    const getWebsiteUrlValue = (whatsapp_template_button_sub_type_field_data: any) => {
        const websiteUrl = whatsapp_template_button_sub_type_field_data?.find((subType: any) => {
            return subType?.field_name?.toLowerCase() == "website url";
        });
        if (websiteUrl) {
            return websiteUrl?.whatsapp_template_button_sub_type_field_value || "";
        }
        return "";
    }

    const flagShowPayloadButton = (field: any, action: any) => {
        const selected_btn_type = whatsappTemplateButtonGenericData?.find((btn: any) => btn.whatsapp_template_button_type_id == action.whatsapp_template_button_type_id);
        if (selected_btn_type) {
            const selected_sub_btn_type = selected_btn_type?.whatsapp_template_button_sub_type_data?.find((btnSubType: any) => btnSubType?.whatsapp_template_button_sub_type_id == field?.whatsapp_template_button_sub_type_id);
            if (selected_sub_btn_type) {
                return selected_sub_btn_type?.whatsapp_template_button_sub_type_name?.toLowerCase() == "custom";
            }
        }
        return false;
    }

    const getInteractiveTypeApi = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await agent.getInteractiveType.get();
        if (!(res.status)) {
            handleError(res);
        } else {
            setInteractiveTypeList(res.data);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        return res?.data ?? null;
    }

    const onChangeOfTypeOfVariable = (value: string) => {
        setCreateTemplatePayload((prev: any) =>( {
            ...prev,
            flag_named_parameter: value == TYPE_OF_VARIABLE['NAME'] ? true : false,
        }))
    }

    const checkTypeOfVariableValidation = (type: string) => {
        const templateHeader = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header;
        const headerVariableData = templateHeader?.whatsapp_template_header_type_name?.toLowerCase() == 'text' ? templateHeader?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data || [] : [];
        const bodyVariableData = createTemplatePayload.whatsapp_template_data.whatsapp_template_body.whatsapp_template_body_variable_data;
        
        const flagNamedParams = createTemplatePayload.flag_named_parameter;

        switch(type?.toLowerCase()){
            case 'header':
                return validateVariableKeys(headerVariableData, flagNamedParams);
            case 'body':
                return validateVariableKeys(bodyVariableData, flagNamedParams);
            case 'both':
                return validateVariableKeys([...headerVariableData, ...bodyVariableData], flagNamedParams)
        }
    }

    const handleExpirationChange = (value: string) => {
        const expireMinutes = Number.parseInt(value, 10);
        const validExpirationMinutes = expireMinutes > 0 && expireMinutes <= 90;

        const updatedFooter = validExpirationMinutes ? renderAuthenticationTemplateFooterText(expireMinutes) : null;

        setCreateTemplatePayload({
            ...createTemplatePayload,
            whatsapp_template_data: {
                ...createTemplatePayload?.whatsapp_template_data,
                whatsapp_template_code_expiration_minutes: validExpirationMinutes ? expireMinutes : null,
                whatsapp_template_footer: {
                    ...createTemplatePayload?.whatsapp_template_data?.whatsapp_template_footer,
                    whatsapp_template_footer_value: updatedFooter ?? "",
                }
            }
        });
    };

    const handleSecurityRecommendationChange = (isChecked: boolean) => {
        const appendText = RENDER_SECURITY_RECOMMENDATION_APPEND_TEXT;
    
        const existingBody = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_body?.whatsapp_template_body_value || "*{{1}}* is your verification code.";
    
        let updatedBody;
    
        if (isChecked) {
            updatedBody = existingBody.includes(appendText) ? existingBody : existingBody + " " + appendText;
        } else {
            updatedBody = existingBody.replace(appendText, "").trim();
        }
    
        setCreateTemplatePayload({
            ...createTemplatePayload,
            whatsapp_template_data: {
                ...createTemplatePayload?.whatsapp_template_data,
                whatsapp_template_security_recommendation: isChecked,
                whatsapp_template_body: {
                    ...createTemplatePayload?.whatsapp_template_data?.whatsapp_template_body,
                    whatsapp_template_body_value: updatedBody,
                }
            }
        });
    };

    // --------------------VARIABLE------------------------- 

    function getTemplateTypeComponent(templateType: string) {
        switch (templateType) {
            case 'carousel':
                return createTemplatePayload?.whatsapp_template_id ?
                    <CarouselTemplateView
                        createTemplatePayload={createTemplatePayload}
                        whastappTemplateHeaderTypes={whastappTemplateHeaderTypes}
                        files={carouselFiles}
                        uploadFileHandler={uploadFileHandlerCarousel}
                        removeFileHandler={removeFileHandlerCarousel}
                        checkForAddDynamicVar={checkForAddDynamicVar}
                        isFileUploaded={isFileUploaded}
                        getInput={getInput}
                        viewPayloadScreen={viewPayloadScreen}
                        anchorEl={anchorEl}
                        open={open}
                        handleClose={handleClose}
                        addBtnOpenMenu={addBtnOpenMenu}
                        whatsappTemplateButtonGenericData={whatsappTemplateButtonGenericData}
                        carouselHeaderText={carouselHeaderText}
                        headerTextareaCarouselRef={headerTextareaCarouselRef}
                        templateStatusDetails={templateStatusDetails}
                        flagShowVariableTooltipForVisitWebsite={flagShowVariableTooltipForVisitWebsite}
                        getWebsiteUrlValue={getWebsiteUrlValue}
                        flagShowPayloadButton={flagShowPayloadButton}
                        existingPayloadKey={existingPayloadKey}
                        menuPosition={menuPosition}
                    />
                    :
                    <CarouselTemplate
                        createTemplatePayload={createTemplatePayload}
                        setFiles={setFiles}
                        setCreateTemplatePayload={setCreateTemplatePayload}
                        whastappTemplateHeaderTypes={whastappTemplateHeaderTypes}
                        handleChangeText={handleChangeText}
                        checkFlagErrorCarousel={checkFlagErrorCarousel}
                        files={carouselFiles}
                        uploadFileHandler={uploadFileHandlerCarousel}
                        removeFileHandler={removeFileHandlerCarousel}
                        footerText={footerText}
                        checkForAddDynamicVar={checkForAddDynamicVar}
                        handleSampleTextChange={handleSampleTextChangeCarousel}
                        inValidId={inValidId}
                        isFileUploaded={isFileUploaded}
                        getInput={getInput}
                        setOnChangeOfPayloadObject={setOnChangeOfPayloadObjectCarousel}
                        handleAddQuickReply={handleAddQuickReply}
                        handleDeleteQuickReply={handleDeleteQuickReply}
                        handleQuickReplyChange={handleQuickReplyChange}
                        quickReply={quickReply}
                        viewPayloadScreen={viewPayloadScreen}
                        anchorEl={anchorEl}
                        open={open}
                        handleClose={handleClose}
                        addBtnOpenMenu={addBtnOpenMenu}
                        whatsappTemplateButtonGenericData={whatsappTemplateButtonGenericData}
                        getMenuDisableFlag={getMenuDisableFlag}
                        handleClick={handleClick}
                        menuPosition={menuPosition}
                        getExistingActionButtonId={getExistingActionButtonIdCarousel}
                        getExistingActionButtonDataId={getExistingActionButtonDataIdCarousel}
                        carouselHeaderText={carouselHeaderText}
                        inValidIdRefCarousel={inValidIdRefCarousel}
                        headerTextareaCarouselRef={headerTextareaCarouselRef}
                        carouselInvalidId={carouselInvalidId}
                        setCarouselInvalidId={setCarouselInvalidId}
                        handleChangeFieldVal={handleChangeFieldVal}
                        handleChangeCallField={handleChangeCallField}
                        setCarouselFiles={setCarouselFiles}
                        getNewBtnType={getNewBtnType}
                        flagShowVariableTooltipForVisitWebsite={flagShowVariableTooltipForVisitWebsite}
                        getWebsiteUrlValue={getWebsiteUrlValue}
                        existingPayloadKey={existingPayloadKey}
                        flagShowPayloadButton={flagShowPayloadButton}
                        setExistingPayloadKey={setExistingPayloadKey}
                        getButtonsIconByName={getButtonsIconByName}
                        addButtonWithSubTypeGrouping={addButtonWithSubTypeGrouping}
                    />
            default:
                return <BasicTemplate
                    createTemplatePayload={createTemplatePayload}
                    setFiles={setFiles}
                    setCreateTemplatePayload={setCreateTemplatePayload}
                    whastappTemplateHeaderTypes={whastappTemplateHeaderTypes}
                    handleChangeText={handleChangeText}
                    checkFlagError={checkFlagError}
                    files={files}
                    uploadFileHandler={uploadFileHandler}
                    removeFileHandler={removeFileHandler}
                    footerText={footerText}
                    checkForAddDynamicVar={checkForAddDynamicVar}
                    handleSampleTextChange={handleSampleTextChange}
                    inValidId={inValidId}
                    isFileUploaded={isFileUploaded}
                    getInput={getInput}
                    setOnChangeOfPayloadObject={setOnChangeOfPayloadObject}
                    handleAddQuickReply={handleAddQuickReply}
                    handleDeleteQuickReply={handleDeleteQuickReply}
                    handleQuickReplyChange={handleQuickReplyChange}
                    quickReply={quickReply}
                    viewPayloadScreen={viewPayloadScreen}
                    text={text}
                    anchorEl={anchorEl}
                    open={open}
                    handleClose={handleClose}
                    addBtnOpenMenu={addBtnOpenMenu}
                    whatsappTemplateButtonGenericData={whatsappTemplateButtonGenericData}
                    getMenuDisableFlag={getMenuDisableFlag}
                    handleAddActionsButton={handleAddActionsButton}
                    handleClick={handleClick}
                    menuPosition={menuPosition}
                    setInvalidId={setInvalidId}
                    inValidIdRef={inValidIdRef}
                    textareaRef={textareaRef}
                    handleChangeFieldVal={handleChangeFieldVal}
                    handleChangeCallField={handleChangeCallField}
                    setExistingHeaderTemplateVariableData={setExistingHeaderTemplateVariableData}
                    flagShowVariableTooltipForVisitWebsite={flagShowVariableTooltipForVisitWebsite}
                    getWebsiteUrlValue={getWebsiteUrlValue}
                    getButtonsIconByName={getButtonsIconByName}
                    isFlowButton={isFlowButton}
                    setPayloadOnChangeOfGetInput={setPayloadOnChangeOfGetInput}
                    invalidPayloadObjectId={invalidPayloadObjectId}
                    setInvalidPayloadObjectId={setInvalidPayloadObjectId}
                    interactiveTypeList={interactiveTypeList}
                    templateStatusDetails={templateStatusDetails}
                    existingTemplateData={existingTemplateData}
                    onChangeOfTypeOfVariable={onChangeOfTypeOfVariable}
                    checkTypeOfVariableValidation={checkTypeOfVariableValidation}
                    handleExpirationChange={handleExpirationChange}
                    handleSecurityRecommendationChange={handleSecurityRecommendationChange}
                    whatsappTemplateTypes={whatsappTemplateTypes}
                />

        }
    }

    const onChangeOfInteractiveMessageSwitch = async (inputValue: boolean) => {
        if (inputValue) {
            const isHeaderTypeVideoOrDocument = ["video", "document"].includes(createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_type_name?.toLowerCase() || "");
            const header_storage_id = createTemplatePayload?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_data_google_storage_id;
            if (isHeaderTypeVideoOrDocument && header_storage_id != 0) {
                // Need to Delete File, when header type is video or document and header file is uploaded. Cause, interactive message don't support video or document in, header.
                removeUploadedFile(header_storage_id, false);
                setFiles([]);
            }

            let listOfInteractiveType = interactiveTypeList;
            if (!interactiveTypeList) {
                listOfInteractiveType = await getInteractiveTypeApi();
            }

            setCreateTemplatePayload((prevState: any) => ({
                ...prevState,
                whatsapp_template_flag_interactive_message: inputValue,
                interactive_type_id: listOfInteractiveType?.find((interactiveType) => isInteractiveTypeNameList(formatString(interactiveType?.interactive_type_name)))?.interactive_type_id ?? null,
                interactive_list_button_text: listOfInteractiveType?.find((interactiveType) => isInteractiveTypeNameList(formatString(interactiveType?.interactive_type_name))) ? defaultButtonTextForListType : null,
                whatsapp_template_type_id: whatsappTemplateTypes?.find((types: any) => types.name.toLowerCase() == "basic")?.whatsapp_template_type_id,
                whatsapp_template_data: {
                    ...prevState.whatsapp_template_data,
                    whatsapp_template_category_id: null,
                    whatsapp_template_button: [], // If Interactive message is enable, we need to add button description in custom button.
                    whatsapp_template_header: { // Set Header to None
                        whatsapp_template_header_type_id: 0,
                        whatsapp_template_header_type_name: "None",
                        whatsapp_template_header_data: [
                            {
                                whatsapp_template_header_data_value: "",
                                whatsapp_template_header_data_id: 0,
                                whatsapp_template_header_data_google_storage_id: 0,
                                whatsapp_template_header_variable_data: []
                            }
                        ]
                    }
                }
            }));
        } else {
            setCreateTemplatePayload((prevState) => ({
                ...prevState,
                whatsapp_template_flag_interactive_message: inputValue,
                interactive_type_id: null,
                interactive_list_button_text: null,
                whatsapp_template_data: {
                    ...prevState.whatsapp_template_data,
                    whatsapp_template_category_id: getTemplateCategoryId(TEMPLATE_CATEGORY?.UTILITY, templateCategoryList ?? []),
                    whatsapp_template_button: [],
                }
            }))
        }
    }

    const onChangeOfInteractiveType = (value: interactiveType | null) => {
        setCreateTemplatePayload((prev) => {
            const updatePayload = {
                ...prev,
                interactive_type_id: value ? value?.interactive_type_id : null,
                interactive_type_name: value ? value?.interactive_type_name : null,
                interactive_list_button_text: (value && isInteractiveTypeNameList(formatString(value?.interactive_type_name))) ? defaultButtonTextForListType : null
            }

            if(value && isInteractiveTypeNameCatalogMessage(formatString(value?.interactive_type_name))){
                const viewCatalogBtnTypeId = getButtonTypeIdByName(whatsappTemplateButtonGenericData ?? [], BTN_TYPE_NAMES['CATALOG']);
                updatePayload.whatsapp_template_data = {
                    ...updatePayload.whatsapp_template_data,
                    whatsapp_template_header: {
                        whatsapp_template_header_type_id: 0,
                        whatsapp_template_header_type_name: "None",
                        whatsapp_template_header_data: [
                            {
                                whatsapp_template_header_data_value: "",
                                whatsapp_template_header_data_id: 0,
                                whatsapp_template_header_data_google_storage_id: 0,
                                whatsapp_template_header_variable_data: []
                            }
                        ]
                    },
                    whatsapp_template_button: [
                        buildCreateFromScratchButton(viewCatalogBtnTypeId, "View catalog", BTN_SUB_TYPE_NAMES['VIEW_CATALOG'], 1, whatsappTemplateButtonGenericData ?? []) as createWhatsappTemplateButton,
                    ],
                }

                return updatePayload;
            }

            if (value) {
                updatePayload.whatsapp_template_data = {
                    ...updatePayload.whatsapp_template_data,
                    whatsapp_template_button: [],
                    whatsapp_template_header: {
                        whatsapp_template_header_type_id: 0,
                        whatsapp_template_header_type_name: "None",
                        whatsapp_template_header_data: [
                            {
                                whatsapp_template_header_data_value: "",
                                whatsapp_template_header_data_id: 0,
                                whatsapp_template_header_data_google_storage_id: 0,
                                whatsapp_template_header_variable_data: []
                            }
                        ]
                    }
                }
            }
            return updatePayload;
        })
    }

    useEffect(() => {
        if (!whatsappTemplateTypes?.length) return;
    
        const carousel = searchParams.get('carousel');
        const interactive = searchParams.get('interactive');

        if(carousel === 'true') {
            setCreateTemplatePayload((prevState: any) => ({
                ...prevState,
                whatsapp_template_type_id: whatsappTemplateTypes?.find((type: any) => type.name?.toLowerCase().trim() === TEMPLATE_TYPES['CAROUSEL']?.toLowerCase())?.whatsapp_template_type_id ?? 0,
                whatsapp_template_data: {
                    ...prevState.whatsapp_template_data,
                    whatsapp_template_category_id: getTemplateCategoryId(TEMPLATE_CATEGORY?.MARKETING, templateCategoryList ?? [])
                }
            }));
        }

        if(interactive === 'true') {
            let listOfInteractiveType = interactiveTypeList;

            (async () => {
                if(!interactiveTypeList) {
                    listOfInteractiveType = await getInteractiveTypeApi();
                }

                setCreateTemplatePayload((prevState: any) => ({
                    ...prevState,
                    whatsapp_template_flag_interactive_message: true,
                    whatsapp_template_type_id: whatsappTemplateTypes?.find((type: any) => type.name?.toLowerCase().trim() === TEMPLATE_TYPES['BASIC']?.toLowerCase())?.whatsapp_template_type_id ?? 0,
                    interactive_type_id: listOfInteractiveType?.find((interactiveType) => isInteractiveTypeNameList(formatString(interactiveType?.interactive_type_name)))?.interactive_type_id ?? null,
                    interactive_list_button_text: listOfInteractiveType?.find((interactiveType) => isInteractiveTypeNameList(formatString(interactiveType?.interactive_type_name))) ? defaultButtonTextForListType : null,
                    whatsapp_template_data: {
                        ...prevState.whatsapp_template_data,
                        whatsapp_template_category_id: null,
                    }
                }));
            })();
        }
    }, [searchParams, whatsappTemplateTypes]);

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container>

                        {/* <Grid item xs={12} sx={{ mb: "0px", padding: { xs: '20px 20px 0px 20px', lg: '25px 25px 0px 27px' }, position: "sticky", top: { xs: "50px", sm: "0" }, backgroundColor: "white", zIndex: { xs: 2, md: 1 } }} >
                            <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                <Grid item xs={12}>
                                    <GlobalPageHeaderText
                                        mainHeadText={"Create Template"}
                                        flagMainTextOnly
                                    />
                                </Grid>
                            </Grid>
                            {!smallScreen && <Divider className={globalStyles.fullwidth} style={{ opacity: "0.8", marginTop: "10px" }} />}
                        </Grid> */}

                        <Grid item xs={12} className={styles.templateDropdownItem} sx={{
                            // padding: { xs: "0px 0px 0px 20px", lg: "0px 0px 0px 22px" }
                        }}>
                            <Grid container sx={{ justifyContent: 'space-between' }} gap={{ xs: 0, lg: 1, xl: 2 }} flexWrap={"nowrap"} direction={{ xs: "column", lg: "row" }}>
                                <Grid item xs={12} lg={7.5} xl={8.5} p={1} className={`${styles.leftBlock} ${globalStyles.fullwidth}`} sx={{ height: `${innerHeight}px !important`, maxHeight: `${innerHeight}px !important` }}>
                                    <Grid container style={{ position: "relative" }}>

                                        {flagSmallScreen &&
                                            <Grid item className={styles.cbDetailsPreviewMainItem} onClick={() => { setOpenSwipableDrawer(true) }}>
                                                <Grid container sx={{ gap: "5px", cursor: "pointer" }}>
                                                    <img
                                                        src={previewIcon}
                                                        className={globalStyles.previewIconStyle}
                                                        alt=""
                                                    />
                                                    <Typography
                                                        component={'span'}
                                                        className={globalStyles.previewIconFont}
                                                    >
                                                        Preview
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        }

                                        <Grid item className={styles.templateSubmitBtnGrid}>
                                            <Button
                                                variant='contained'
                                                size='medium'
                                                className={styles.templateSubmitBtn}
                                                onClick={isCarouselTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) ? handleSubmitCarouselTemplate : handleSubmitTemplate}
                                                disabled={handleSubmitTemplateDisabled()}
                                                style={{ opacity: handleSubmitTemplateDisabled() ? "0.5" : "1" }}
                                            >
                                                {createTemplatePayload.whatsapp_template_id ? "Update Template Message" : "Create Template Message"}
                                            </Button>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <Grid container>
                                                <Grid item xs={12} className={styles.templateFieldBetweenSpacing}>
                                                    <Typography component={'span'} className={styles.templateHeadtext}>
                                                        Template Category
                                                    </Typography>
                                                    <Required />
                                                </Grid>
                                                <Grid item xs={12} className={styles.templateFieldBetweenSpacing}>
                                                    <Typography component={'span'} className={styles.templateSubHeadtext}>
                                                        Choose the category that best describes your message template.{" "}
                                                        <a
                                                            href={META_DOCUMENTATION_URLS.WHATSAPP_TEMPLATE_CATEGORIZATION}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className={styles.templateLink}
                                                        >
                                                            Learn more about categories
                                                        </a>
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sx={{ margin: '5px 0px 0px' }}>
                                                    <Grid container gap={{ xs: "12px", lg: 2 }}>
                                                        {templateCategoryList?.map((option: any, ind: number) => (
                                                            // <MenuItem value={option.whatsapp_template_category_id} key={option.whatsapp_template_category_id}>
                                                            //     {option.whatsapp_template_category_name}
                                                            // </MenuItem>
                                                            <Grid item
                                                                key={ind}
                                                                className={styles.categoryFields}
                                                                style={{ cursor: flagCategoryEditable(createTemplatePayload, option.whatsapp_template_category_id) ? "pointer" : "unset", opacity: flagCategoryEditable(createTemplatePayload, option.whatsapp_template_category_id) ? "" : "0.5", backgroundColor: option.whatsapp_template_category_id === createTemplatePayload.whatsapp_template_data.whatsapp_template_category_id ? tertiaryColor : "#FFFFFF" }}
                                                                onClick={() => {
                                                                    if (flagCategoryEditable(createTemplatePayload, option.whatsapp_template_category_id)) {
                                                                        // setCreateTemplatePayload((prevState) => ({ ...prevState, whatsapp_template_data: { ...prevState.whatsapp_template_data, whatsapp_template_category_id: option.whatsapp_template_category_id } }))
                                                                        handleCategoryChange(option?.whatsapp_template_category_id);
                                                                    } else {

                                                                    }
                                                                }}>
                                                                <span>{option.whatsapp_template_category_name}</span>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} className={styles.marginTop20}>
                                            <Grid container>
                                                <Grid item xs={12} className={styles.templateFieldBetweenSpacing}>
                                                    <Typography component={'span'} className={styles.templateHeadtext}>
                                                        Template Type
                                                    </Typography>
                                                    <Required />
                                                </Grid>
                                                <Grid item xs={12} sx={{ margin: '5px 0px 0px' }}>
                                                    <Autocomplete
                                                        disabled={(createTemplatePayload.whatsapp_template_id || isAuthenticationTemplate) ? true : false}
                                                        fullWidth
                                                        size='small'
                                                        disablePortal
                                                        className={styles.callToActionAutocomplete}
                                                        sx={{
                                                            '& .MuiInputBase-sizeSmall': {
                                                                paddingBlock: "9px !important",
                                                                borderRadius: "10px"
                                                            }
                                                        }}
                                                        options={whatsappTemplateTypes || []}
                                                        getOptionLabel={(option: any) => option?.name}
                                                        value={whatsappTemplateTypes && whatsappTemplateTypes?.find((types) => types.whatsapp_template_type_id == createTemplatePayload?.whatsapp_template_type_id)}
                                                        renderInput={(params) => <TextField {...params} placeholder="Select template type" />}
                                                        onChange={(event, value) => {
                                                            if (createTemplatePayload?.whatsapp_template_flag_interactive_message && value?.name?.toLowerCase() !== TEMPLATE_TYPES['BASIC']?.toLowerCase()) {
                                                                setCreateTemplatePayload((prevState) => ({
                                                                    ...prevState,
                                                                    whatsapp_template_type_id: value?.whatsapp_template_type_id || 0,
                                                                    whatsapp_template_flag_interactive_message: false,
                                                                    interactive_list_button_text: null,
                                                                    interactive_type_id: null,
                                                                    whatsapp_template_data: { ...prevState?.whatsapp_template_data, whatsapp_template_category_id: getTemplateCategoryId(TEMPLATE_CATEGORY?.MARKETING, templateCategoryList ?? []) }
                                                                }
                                                                ));
                                                            } else {
                                                                setCreateTemplatePayload((prevState) => ({
                                                                    ...prevState,
                                                                    whatsapp_template_type_id: value?.whatsapp_template_type_id || 0,
                                                                    whatsapp_template_data: { ...prevState?.whatsapp_template_data, whatsapp_template_category_id: getTemplateCategoryId(TEMPLATE_CATEGORY?.MARKETING, templateCategoryList ?? []) }
                                                                }
                                                                ));
                                                            }

                                                            if(value?.name?.toLowerCase() === TEMPLATE_TYPES['CATALOG']?.toLowerCase()){
                                                                const viewCatalogBtnTypeId = getButtonTypeIdByName(whatsappTemplateButtonGenericData ?? [], BTN_TYPE_NAMES['CATALOG']);
                                                                setCreateTemplatePayload((prevState: any) => ({
                                                                        ...prevState,
                                                                        whatsapp_template_data: { 
                                                                            ...prevState?.whatsapp_template_data,  
                                                                            whatsapp_template_header: {
                                                                                whatsapp_template_header_type_id: 0,
                                                                                whatsapp_template_header_type_name: "None",
                                                                                whatsapp_template_header_data: [
                                                                                    {
                                                                                        whatsapp_template_header_data_value: "",
                                                                                        whatsapp_template_header_data_id: 0,
                                                                                        whatsapp_template_header_data_google_storage_id: 0,
                                                                                        whatsapp_template_header_variable_data: []
                                                                                    }
                                                                                ]
                                                                            },
                                                                            whatsapp_template_button: [
                                                                                buildCreateFromScratchButton(viewCatalogBtnTypeId, "View catalog", BTN_SUB_TYPE_NAMES['VIEW_CATALOG'], 1, whatsappTemplateButtonGenericData ?? []),
                                                                            ],
                                                                        }
                                                                    }
                                                                ));
                                                            } else {
                                                                setCreateTemplatePayload((prevState: any) => ({
                                                                        ...prevState,
                                                                        whatsapp_template_data: { 
                                                                            ...prevState?.whatsapp_template_data,
                                                                            whatsapp_template_button: [],
                                                                        }
                                                                    }
                                                                ));
                                                            }

                                                        }}
                                                    />
                                                </Grid>
                                                {/* interactive type */}
                                                {isBasicTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) &&
                                                    <Grid item xs={12} sx={{ margin: '5px 0px 0px' }}>
                                                        <FormControlLabel
                                                            className={styles.interactiveMessageFontStyle}
                                                            control={
                                                                <IOSSwitch sx={{ m: 1 }}
                                                                    checked={createTemplatePayload.whatsapp_template_flag_interactive_message}
                                                                    disabled={createTemplatePayload?.whatsapp_template_id || isAuthenticationTemplate || getTemplateTypeName(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) != "basic" ? true : false}
                                                                    onChange={(e) => onChangeOfInteractiveMessageSwitch(e.target.checked)}
                                                                />
                                                            }
                                                            label="Interactive Message"
                                                        />
                                                    </Grid>
                                                }
                                                {/* end */}
                                            </Grid>
                                        </Grid>
                                        {createTemplatePayload.whatsapp_template_flag_interactive_message &&
                                            <Grid item xs={12} className={styles.marginTop20}>
                                                <Grid container>
                                                    <Grid item xs={12} className={styles.templateFieldBetweenSpacing}>
                                                        <Typography component={'span'} className={styles.templateHeadtext}>
                                                            Interactive Message Type
                                                        </Typography>
                                                        <Required />
                                                    </Grid>
                                                    <Grid item xs={12} sx={{ margin: '5px 0px 0px' }}>
                                                        <Autocomplete
                                                            disabled={createTemplatePayload.whatsapp_template_id ? true : false}
                                                            fullWidth
                                                            size='small'
                                                            disablePortal
                                                            className={styles.callToActionAutocomplete}
                                                            sx={{
                                                                '& .MuiInputBase-sizeSmall': {
                                                                    paddingBlock: "9px !important",
                                                                    borderRadius: "10px"
                                                                }
                                                            }}
                                                            options={interactiveTypeList || []}
                                                            getOptionLabel={(option: any) => formatString(option?.interactive_type_name ?? "")}
                                                            value={interactiveTypeList?.find((type: interactiveType) => type?.interactive_type_id == createTemplatePayload?.interactive_type_id) ?? null}
                                                            renderInput={(params) => <TextField {...params} placeholder="Select interactive message type" />}
                                                            onChange={(event, value) => onChangeOfInteractiveType(value)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                        <Grid item xs={12} className={styles.marginTop20}>
                                            <Grid container>
                                                <Grid item xs={12} className={styles.templateFieldBetweenSpacing}>
                                                    <Typography component={'span'} className={styles.templateHeadtext}>
                                                        Template Name
                                                    </Typography>
                                                    <Required />
                                                    {createTemplatePayload.whatsapp_template_id &&
                                                        <Tooltip title={"You can not edit a template name once created"}>
                                                            <InfoIcon sx={{ fontSize: "17px", marginLeft: "7px", cursor: "pointer" }} />
                                                        </Tooltip>}
                                                </Grid>
                                                <Grid item xs={12} className={styles.templateFieldBetweenSpacing}>
                                                    <Typography component={'span'} className={styles.templateSubHeadtext}>
                                                        Name can only be in lowercase alphanumeric characters and underscores. Special characters and white-space are not allowed
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} className={styles.templateFieldBetweenSpacing}>
                                                    <Typography component={'span'} className={styles.templateSubHeadtext}>
                                                        e.g app_verification_code
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12} sx={{ margin: '5px 0px 0px' }}>
                                                    <TextField
                                                        disabled={createTemplatePayload.whatsapp_template_id ? true : false}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                        className={styles.templateGlobalTextfield}
                                                        placeholder='Enter message template name...'
                                                        size='medium'
                                                        onChange={(e) => {
                                                            if (e.target.value.length > TEMPLATE_NAME_MAX_LIMIT) {
                                                                showInfo(TEMPLATE_NAME_MAX_CHARS_MESSAGE)
                                                                return;
                                                            } else {
                                                                const inputValue = e.target.value;
                                                                const sanitizedValue = inputValue.replace(/ /g, '_').replace(/[^a-z0-9_]/g, '');
                                                                setCreateTemplatePayload((prevState) => ({
                                                                    ...prevState,
                                                                    whatsapp_template_data: {
                                                                        ...prevState.whatsapp_template_data,
                                                                        whatsapp_template_name: sanitizedValue
                                                                    }
                                                                }));
                                                            }
                                                        }}
                                                        FormHelperTextProps={{
                                                            style: {
                                                                textAlign: 'right',
                                                                fontSize: '13px',
                                                                fontWeight: '600'
                                                            }
                                                        }}
                                                        helperText={`${createTemplatePayload.whatsapp_template_data.whatsapp_template_name.length}/${TEMPLATE_NAME_MAX_LIMIT}`}
                                                        // onChange={(e) => { setCreateTemplatePayload((prevState) => ({ ...prevState, whatsapp_template_data: { ...prevState.whatsapp_template_data, whatsapp_template_name: e.target.value } })) }}
                                                        value={createTemplatePayload.whatsapp_template_data.whatsapp_template_name}
                                                        autoComplete='off'
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        {!createTemplatePayload.whatsapp_template_flag_interactive_message &&
                                            <Grid item xs={12} className={styles.marginTop20}>
                                                <Grid container>
                                                    <Grid item xs={12} className={styles.templateFieldBetweenSpacing}>
                                                        <Typography component={'span'} className={styles.templateHeadtext}>
                                                            Template Language
                                                        </Typography>
                                                        <Required />
                                                        {createTemplatePayload.whatsapp_template_id &&
                                                            <Tooltip title={"You can not edit a template language once created"}>
                                                                <InfoIcon sx={{ fontSize: "17px", marginLeft: "7px", cursor: "pointer" }} />
                                                            </Tooltip>}
                                                    </Grid>
                                                    <Grid item xs={12} className={styles.templateFieldBetweenSpacing}>
                                                        <Typography component={'span'} className={styles.templateSubHeadtext}>
                                                            You will need to specify the language in which message template is submitted
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sx={{ margin: '5px 0px 0px' }}>
                                                        <Select
                                                            disabled={createTemplatePayload.whatsapp_template_id ? true : false}
                                                            labelId="demo-simple-select-label"
                                                            id="demo-simple-select"
                                                            placeholder='Select message language'
                                                            fullWidth
                                                            size='medium'
                                                            value={createTemplatePayload.whatsapp_template_data?.whatsapp_language_id}
                                                            onChange={(e: any) => {
                                                                setCreateTemplatePayload((prevState) => ({ ...prevState, whatsapp_template_data: { ...prevState.whatsapp_template_data, whatsapp_language_id: e.target.value } }))
                                                            }}
                                                            className={styles.templateGlobalDropdown}
                                                            MenuProps={{
                                                                anchorOrigin: {
                                                                    vertical: 'bottom',
                                                                    horizontal: 'left',
                                                                },
                                                                transformOrigin: {
                                                                    vertical: 'top',
                                                                    horizontal: 'left',
                                                                },
                                                                PaperProps: {
                                                                    style: {
                                                                        maxHeight: 250,
                                                                    },
                                                                },
                                                            }}
                                                        >

                                                            {whatsappTemplateLanguages.map((option: any, ind: number) => (
                                                                <MenuItem value={option.whatsapp_language_id} key={ind}>
                                                                    {option?.whatsapp_language_name}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                        <Grid item xs={12} className={styles.marginTop20}>
                                            <Grid container>
                                                <Grid item xs={12} className={styles.templateFieldBetweenSpacing}>
                                                    <Typography component={'span'} className={styles.templateHeadtext}>
                                                        Template Description (optional)
                                                    </Typography>
                                                    {/* <Required /> */}
                                                </Grid>
                                                <Grid item xs={12} sx={{ margin: '5px 0px 0px' }}>
                                                    <TextField
                                                        disabled={createTemplatePayload.whatsapp_template_id ? true : false}
                                                        id="outlined-basic"
                                                        variant="outlined"
                                                        fullWidth
                                                        className={styles.templateGlobalTextfield}
                                                        placeholder='Enter template description..'
                                                        size='medium'
                                                        autoComplete='off'
                                                        onChange={(e) => {
                                                            setCreateTemplatePayload((prevState) => ({ ...prevState, whatsapp_template_data: { ...prevState.whatsapp_template_data, whatsapp_template_description: e.target.value } }))
                                                        }}
                                                        value={createTemplatePayload.whatsapp_template_data.whatsapp_template_description}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item xs={12} className={styles.marginTop20}>
                                            <Grid container>
                                                <Grid item xs={12} className={styles.templateFieldBetweenSpacing}>
                                                    <Typography component={'span'} className={styles.templateHeadtext}>
                                                        Template Details
                                                    </Typography>
                                                    <Required />
                                                </Grid>
                                                {/* Code for Template type Basic and currently for Flow(temporary) */}
                                                {getTemplateTypeComponent(getTemplateTypeName(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id))}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {!flagSmallScreen &&
                                    <Grid item xs={12} lg={4} xl={3} className={globalStyles.fullwidth}>
                                        <Grid container direction={"column"} justifyContent={'center'}>
                                            {!createTemplatePayload?.whatsapp_template_id && isCarouselTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) &&
                                                <TemplatePreviewCarousel metaInformation={createTemplatePayload} whatsappTemplateButtonGenericData={whatsappTemplateButtonGenericData} />
                                            }
                                            {createTemplatePayload?.whatsapp_template_id && isCarouselTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) &&
                                                <TemplatePreviewCarouselView metaInformation={templateStatusDetails} whatsappTemplateButtonGenericData={whatsappTemplateButtonGenericData} />
                                            }
                                            {(isBasicTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) || isCatalogTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)) &&
                                                <Grid item className={globalStyles.fullwidth}>
                                                    <BasicTemplatePreview metaInformation={createTemplatePayload} interactiveTypeList={interactiveTypeList} whatsappTemplateButtonGenericData={whatsappTemplateButtonGenericData} />
                                                </Grid>
                                            }
                                        </Grid>
                                    </Grid>
                                }


                                {flagSmallScreen &&
                                    <Grid item xs={flagSmallScreen ? 0 : 6}>
                                        {!createTemplatePayload?.whatsapp_template_id && isCarouselTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)&&
                                            <TemplatePreviewCarouselMobile
                                                metaInformation={createTemplatePayload}
                                                flagSmallScreen={flagSmallScreen}
                                                setOpenSwipableDrawer={setOpenSwipableDrawer}
                                                openSwipableDrawer={openSwipableDrawer}
                                                toggleDrawer={toggleDrawer}
                                                whatsappTemplateButtonGenericData={whatsappTemplateButtonGenericData}
                                            />
                                        }
                                        {createTemplatePayload?.whatsapp_template_id && isCarouselTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) &&
                                            <TemplatePreviewCarouselMobileView
                                                metaInformation={templateStatusDetails}
                                                flagSmallScreen={flagSmallScreen}
                                                setOpenSwipableDrawer={setOpenSwipableDrawer}
                                                openSwipableDrawer={openSwipableDrawer}
                                                toggleDrawer={toggleDrawer}
                                                whatsappTemplateButtonGenericData={whatsappTemplateButtonGenericData}
                                            />
                                        }
                                        {(isBasicTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id) || isCatalogTemplate(whatsappTemplateTypes, createTemplatePayload?.whatsapp_template_type_id)) &&
                                            <TemplatePreviewMobile
                                                metaInformation={createTemplatePayload}
                                                flagSmallScreen={flagSmallScreen}
                                                setOpenSwipableDrawer={setOpenSwipableDrawer}
                                                openSwipableDrawer={openSwipableDrawer}
                                                toggleDrawer={toggleDrawer}
                                                interactiveTypeList={interactiveTypeList}
                                                whatsappTemplateButtonGenericData={whatsappTemplateButtonGenericData}
                                            />
                                        }
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid >
        </>
    )
}


export default TemplateDetails